import { mobileOffers } from "src/lib/offres";
import { AbonnementCard } from "./card";
import { Offer } from "../offres-main";

export const CartesEtAbonnementsScreen = () => {
  return (
    <div>
      <div
        data-nosnippet="true"
        aria-hidden="true"
        style={{ boxSizing: "border-box" }}
      ></div>
      <iframe
        name="__tcfapiLocator"
        title="__tcfapiLocator"
        style={{ display: "none", boxSizing: "border-box" }}
      ></iframe>
      <div
        style={{
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          margin: "0px",
          minHeight: "858px",
          padding: "0px",
        }}
      >
        <div
          style={{
            boxSizing: "border-box",
            backgroundColor: "rgb(243, 243, 248)",
            display: "flex",
            left: "-9999px",
            position: "absolute",
            zIndex: 1201,
          }}
        >
          <a
            href="#main"
            style={{
              boxSizing: "border-box",
              backgroundColor: "rgba(0, 0, 0, 0)",
              margin: "0px",
              fontFamily: "Avenir",
              fontSize: "13px",
              lineHeight: "18px",
              fontWeight: 500,
              color: "rgb(20, 112, 138)",
              textDecoration: "none solid rgb(20, 112, 138)",
              cursor: "pointer",
              position: "relative",
              WebkitBoxAlign: "center",
              alignItems: "center",
              display: "flex",
              padding: "15px",
              boxShadow: "none",
              WebkitBoxPack: "center",
              justifyContent: "center",
              textTransform: "none",
            }}
          >
            Aller au contenu principal
          </a>
        </div>
        <link
          rel="preconnect"
          href="https://decision.flagship.io"
          style={{ boxSizing: "border-box" }}
        />
        <div style={{ display: "block", boxSizing: "border-box" }}>
          <div
            style={{
              boxSizing: "border-box",
              WebkitBoxAlign: "center",
              alignItems: "center",
              backgroundColor: "rgb(12, 19, 31)",
              display: "flex",
              height: "48px",
              WebkitBoxPack: "justify",
              justifyContent: "space-between",
              padding: "0px 16px",
              position: "relative",
              zIndex: 1202,
            }}
          >
            <a
              aria-label="Retour à l'accueil SNCF Connect"
              href="/"
              style={{
                boxSizing: "border-box",
                backgroundColor: "rgba(0, 0, 0, 0)",
                margin: "0px",
                fontFamily: "Avenir",
                fontSize: "13px",
                lineHeight: "18px",
                fontWeight: 500,
                color: "rgb(141, 232, 254)",
                textDecoration: "none solid rgb(141, 232, 254)",
                cursor: "pointer",
                position: "relative",
                display: "flex",
                WebkitBoxAlign: "center",
                alignItems: "center",
                WebkitBoxPack: "center",
                justifyContent: "center",
                height: "48px",
              }}
            >
              <svg
                aria-hidden="true"
                viewBox="0 0 130 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ boxSizing: "border-box", height: "48px" }}
              >
                <path
                  d="M33.593 11.955H10.276C4.594 11.955 0 16.575 0 22.255a10.268 10.268 0 0 0 10.276 10.276h23.317A10.268 10.268 0 0 0 43.87 22.256c0-5.682-4.595-10.3-10.276-10.3ZM4.57 42.288c-.89 0-1.804.321-1.804 1.21 0 .865.865 1.063 2.421 1.433 1.655.395 3.607 1.136 3.607 3.36 0 2.717-2.224 3.73-4.669 3.73-1.235 0-2.643-.347-3.507-1.014-.494-.37-.618-.79-.618-1.111 0-.642.494-1.186 1.16-1.186.297 0 .594.1.964.37.643.52 1.359.791 2.15.791.814 0 1.827-.32 1.827-1.334 0-.938-.89-1.185-2.593-1.58-1.655-.396-3.31-1.063-3.31-3.187 0-2.495 2.223-3.557 4.446-3.557 1.111 0 2.297.272 3.087.865.544.395.667.765.667 1.087 0 .617-.444 1.136-1.136 1.136-.247 0-.519-.099-.815-.321-.593-.494-1.21-.692-1.877-.692Zm6.644-.519c0-1.26.914-1.457 1.334-1.457.42 0 1.334.198 1.334 1.457v.544h.05c.493-1.112 1.827-2.125 3.457-2.125 2.915 0 4.126 2.224 4.126 4.52v5.633c0 1.333-.94 1.556-1.409 1.556-.469 0-1.407-.223-1.407-1.556v-4.842c0-1.334-.297-2.989-2.1-2.989-1.779 0-2.618 1.532-2.618 3.039v4.792c0 1.333-.939 1.556-1.408 1.556-.47 0-1.408-.223-1.408-1.556v-8.572h.05Zm21.44 7.09c.717 0 1.137.543 1.137 1.111 0 .395-.124.79-.741 1.235-.79.568-2.026.815-2.989.815-3.335 0-5.953-2.198-5.953-5.903 0-3.631 2.692-5.904 5.978-5.904 1.062 0 2.149.247 2.94.79.641.445.79.89.79 1.211 0 .617-.47 1.21-1.21 1.21-.248 0-.52-.074-.94-.37a2.678 2.678 0 0 0-1.58-.519c-2.05 0-3.063 1.828-3.063 3.582 0 1.754.988 3.557 3.063 3.557.617 0 1.16-.149 1.655-.47.37-.247.667-.346.914-.346Zm4.1-6.102c-1.061 0-1.259-.74-1.259-1.111 0-.37.198-1.112 1.26-1.112h1.062V38.88c0-2.667 1.038-5.063 4.273-5.063 1.161 0 1.779.395 1.779 1.235 0 .617-.42 1.136-1.31 1.136-1.506 0-1.95.963-1.95 2.52v1.827h1.53c1.063 0 1.26.741 1.26 1.112 0 .37-.197 1.111-1.26 1.111h-1.53v7.584c0 1.333-.94 1.556-1.409 1.556-.444 0-1.408-.223-1.408-1.556v-7.584h-1.037Z"
                  fill="#8DE8FE"
                  style={{ boxSizing: "border-box" }}
                ></path>
                <path
                  d="M56.121 11.955a10.268 10.268 0 0 0-10.275 10.276A10.268 10.268 0 0 0 56.12 32.507 10.268 10.268 0 0 0 66.397 22.23 10.268 10.268 0 0 0 56.12 11.955ZM54.392 48.858c.716 0 1.136.544 1.136 1.112 0 .395-.124.79-.741 1.235-.79.568-2.026.815-2.99.815-3.334 0-5.977-2.198-5.977-5.928 0-3.631 2.717-5.928 6.003-5.928 1.062 0 2.149.246 2.939.79.642.445.79.89.79 1.21 0 .618-.469 1.21-1.21 1.21-.247 0-.519-.073-.938-.37a2.678 2.678 0 0 0-1.581-.519c-2.05 0-3.088 1.853-3.088 3.582 0 1.754.988 3.557 3.088 3.557.617 0 1.16-.148 1.655-.47.37-.172.666-.296.913-.296Zm8.768 3.187c-3.384 0-6.076-2.446-6.076-5.978 0-3.532 2.717-5.879 6.076-5.879 3.384 0 6.077 2.347 6.077 5.879 0 3.508-2.693 5.978-6.077 5.978Zm0-9.584c-2.223 0-3.235 1.852-3.235 3.581 0 1.754 1.037 3.631 3.235 3.631 2.223 0 3.236-1.877 3.236-3.63 0-1.73-1.037-3.582-3.236-3.582Zm8.473-.692c0-1.26.914-1.482 1.334-1.482.42 0 1.333.198 1.333 1.482v.544h.05c.494-1.112 1.828-2.125 3.483-2.125 2.914 0 4.125 2.248 4.125 4.52v5.657c0 1.334-.939 1.556-1.408 1.556-.47 0-1.408-.222-1.408-1.556v-4.841c0-1.334-.297-2.99-2.1-2.99-1.778 0-2.618 1.532-2.618 3.039v4.817c0 1.334-.939 1.556-1.408 1.556-.47 0-1.408-.222-1.408-1.556v-8.62h.025Zm13.091 0c0-1.26.914-1.482 1.334-1.482.42 0 1.334.198 1.334 1.482v.544h.05c.493-1.112 1.827-2.125 3.482-2.125 2.915 0 4.125 2.248 4.125 4.52v5.657c0 1.334-.939 1.556-1.408 1.556-.47 0-1.408-.222-1.408-1.556v-4.841c0-1.334-.296-2.99-2.1-2.99-1.778 0-2.618 1.532-2.618 3.039v4.817c0 1.334-.938 1.556-1.407 1.556-.47 0-1.409-.222-1.409-1.556v-8.62h.025Zm15.414 5.237c.123 1.58 1.556 2.742 3.186 2.742 1.161 0 1.877-.371 2.569-.964.395-.321.642-.395.963-.395.618 0 1.112.444 1.112 1.111 0 .223-.099.643-.47 1.013-1.086 1.038-2.346 1.507-4.149 1.507-3.459 0-6.027-2.223-6.027-5.854 0-3.606 2.544-6.002 5.928-6.002 2.717 0 4.891 1.531 5.335 4.816.025.223.05.395.05.593 0 .988-.544 1.408-1.458 1.408h-7.039v.025Zm5.73-2.026c0-1.457-.815-2.717-2.643-2.717-1.655 0-2.989 1.136-3.112 2.717h5.755Zm13.092 3.878c.716 0 1.136.544 1.136 1.112 0 .395-.124.79-.741 1.235-.791.568-2.026.815-2.989.815-3.335 0-5.978-2.198-5.978-5.928 0-3.631 2.718-5.928 6.003-5.928 1.062 0 2.149.246 2.939.79.642.445.791.89.791 1.21 0 .618-.47 1.21-1.211 1.21-.247 0-.518-.073-.938-.37a2.68 2.68 0 0 0-1.581-.519c-2.05 0-3.088 1.853-3.088 3.582 0 1.754.988 3.557 3.088 3.557.617 0 1.161-.148 1.655-.47.37-.172.667-.296.914-.296Zm8.25 3.088c-2.964 0-3.607-1.828-3.607-3.977v-5.237h-.914c-1.062 0-1.259-.74-1.259-1.111 0-.37.197-1.112 1.259-1.112h.914v-1.926c0-1.285.914-1.507 1.384-1.507.469 0 1.383.222 1.383 1.507v1.926h1.754c1.062 0 1.259.741 1.259 1.112 0 .37-.197 1.111-1.259 1.111h-1.754v5.212c0 1.087.37 1.68 1.062 1.68.124 0 .272-.025.445-.05.197-.024.222-.024.321-.024.691 0 1.062.519 1.062 1.037 0 .445-.247.815-.667 1.038a3.085 3.085 0 0 1-1.383.32Z"
                  fill="#fff"
                  style={{ boxSizing: "border-box" }}
                ></path>
                <path
                  d="M39.868 25.592a7.484 7.484 0 1 0-13.388-6.694 7.484 7.484 0 0 0 13.388 6.694Z"
                  fill="#0C131F"
                  style={{ boxSizing: "border-box" }}
                ></path>
              </svg>
            </a>
          </div>
        </div>
        <header
          role="banner"
          style={{ boxSizing: "border-box", color: "rgb(243, 243, 244)" }}
        >
          <div style={{ display: "block", boxSizing: "border-box" }}>
            <nav
              role="navigation"
              aria-label="Menu principal"
              data-test="tabBar-header"
              style={{
                zIndex: 1202,
                boxSizing: "border-box",
                backgroundColor: "rgb(12, 19, 31)",
                bottom: "0px",
                height: "58px",
                left: "0px",
                position: "fixed",
                right: "0px",
              }}
            >
              <ul
                role="list"
                style={{
                  boxSizing: "border-box",
                  listStyle: "outside none none",
                  margin: "0px",
                  padding: "0px",
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(2rem, 1fr))",
                  WebkitBoxPack: "center",
                  justifyContent: "center",
                  height: "58px",
                  width: "100%",
                }}
              >
                <li style={{ boxSizing: "border-box" }}>
                  <button
                    type="button"
                    aria-label="Menu Voyager"
                    aria-controls="tabBar-panelContent-0"
                    aria-expanded="false"
                    style={{
                      boxSizing: "border-box",
                      appearance: "button",
                      textTransform: "none",
                      overflow: "visible",
                      fontFamily: "Avenir",
                      fontSize: "14px",
                      lineHeight: "24.5px",
                      margin: "0px",
                      display: "inline-flex",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      WebkitBoxPack: "center",
                      justifyContent: "center",
                      position: "relative",
                      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                      backgroundColor: "rgba(0, 0, 0, 0)",
                      outline: "rgb(243, 243, 244) none 0px",
                      border: "0px none rgb(243, 243, 244)",
                      cursor: "pointer",
                      userSelect: "none",
                      verticalAlign: "middle",
                      textDecoration: "none solid rgb(243, 243, 244)",
                      fontWeight: 500,
                      minWidth: "64px",
                      borderRadius: "14px",
                      transition:
                        "background-color 0.25s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.25s cubic-bezier(0.4, 0, 0.2, 1), color 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                      color: "rgb(243, 243, 244)",
                      padding: "0px",
                      height: "58px",
                      width: "100%",
                      whiteSpace: "pre",
                    }}
                  >
                    <div
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        height: "58px",
                      }}
                    >
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          boxSizing: "border-box",
                          height: "24px",
                          width: "1.5rem",
                          fill: "rgb(243, 243, 244)",
                          flexShrink: 0,
                          margin: "8px 0px 4px",
                        }}
                      >
                        <path
                          d="M19 15C18.2925 15.0019 17.6083 15.2538 17.0685 15.7113C16.5287 16.1688 16.168 16.8023 16.05 17.5H7.65003C6.84156 17.5297 6.0431 17.3135 5.36003 16.88C5.09371 16.6953 4.87628 16.4485 4.72647 16.1611C4.57665 15.8737 4.49895 15.5541 4.50003 15.23C4.4716 14.8369 4.53649 14.4427 4.68943 14.0795C4.84236 13.7163 5.079 13.3944 5.38003 13.14C6.04631 12.6841 6.84373 12.4593 7.65003 12.5H16C16.8515 12.4777 17.6728 12.1794 18.34 11.65C18.7372 11.2878 19.0477 10.8409 19.2485 10.3423C19.4493 9.84373 19.5353 9.30634 19.5 8.77001C19.5114 8.2984 19.4113 7.83077 19.208 7.40508C19.0048 6.97938 18.7039 6.60763 18.33 6.32001C17.55 5.76186 16.6089 5.47392 15.65 5.50001H8.00003C7.87466 4.75831 7.47523 4.09077 6.8809 3.62968C6.28656 3.1686 5.5407 2.94761 4.79111 3.01051C4.04153 3.07342 3.34293 3.41563 2.83375 3.96932C2.32458 4.52301 2.04199 5.24779 2.04199 6.00001C2.04199 6.75223 2.32458 7.477 2.83375 8.03069C3.34293 8.58438 4.04153 8.92659 4.79111 8.9895C5.5407 9.0524 6.28656 8.83142 6.8809 8.37033C7.47523 7.90924 7.87466 7.2417 8.00003 6.50001H15.7C16.4353 6.4694 17.16 6.68398 17.76 7.11001C18.0149 7.30336 18.2196 7.55501 18.3571 7.84386C18.4945 8.1327 18.5607 8.4503 18.55 8.77001C18.5817 9.15843 18.5253 9.54899 18.3851 9.91259C18.2448 10.2762 18.0243 10.6035 17.74 10.87C17.1688 11.3098 16.4602 11.533 15.74 11.5H7.74003C6.70744 11.4538 5.68938 11.7568 4.85003 12.36C4.41249 12.6961 4.06166 13.132 3.82681 13.6312C3.59197 14.1305 3.47993 14.6786 3.50003 15.23C3.49277 15.714 3.60594 16.1922 3.82937 16.6216C4.05281 17.0511 4.37949 17.4182 4.78003 17.69C5.63042 18.2492 6.63277 18.5321 7.65003 18.5H16.05C16.1454 19.0643 16.4002 19.5896 16.7844 20.0138C17.1686 20.438 17.6661 20.7435 18.2182 20.8941C18.7703 21.0448 19.354 21.0344 19.9004 20.8642C20.4468 20.694 20.9331 20.371 21.302 19.9334C21.6708 19.4958 21.9068 18.9618 21.982 18.3945C22.0573 17.8272 21.9687 17.2501 21.7267 16.7315C21.4847 16.2129 21.0994 15.7743 20.6163 15.4675C20.1331 15.1607 19.5723 14.9985 19 15ZM19 20C18.6045 20 18.2178 19.8827 17.8889 19.6629C17.56 19.4432 17.3036 19.1308 17.1523 18.7654C17.0009 18.3999 16.9613 17.9978 17.0385 17.6098C17.1156 17.2219 17.3061 16.8655 17.5858 16.5858C17.8655 16.3061 18.2219 16.1156 18.6099 16.0384C18.9978 15.9613 19.3999 16.0009 19.7654 16.1522C20.1309 16.3036 20.4432 16.56 20.663 16.8889C20.8827 17.2178 21 17.6044 21 18C21 18.5304 20.7893 19.0391 20.4142 19.4142C20.0392 19.7893 19.5305 20 19 20Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                      <span
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          height: "22px",
                          position: "relative",
                        }}
                      >
                        <span
                          style={{
                            boxSizing: "border-box",
                            margin: "0px",
                            maxWidth: "96px",
                            fontFamily:
                              "Avenir",
                            fontSize: "11px",
                            lineHeight: "14px",
                            fontWeight: 500,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          Voyager
                        </span>
                      </span>
                    </div>
                  </button>
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <button
                    type="button"
                    aria-label="Menu Billets"
                    aria-controls="tabBar-panelContent-1"
                    aria-expanded="false"
                    style={{
                      boxSizing: "border-box",
                      appearance: "button",
                      textTransform: "none",
                      overflow: "visible",
                      fontFamily: "Avenir",
                      fontSize: "14px",
                      lineHeight: "24.5px",
                      margin: "0px",
                      display: "inline-flex",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      WebkitBoxPack: "center",
                      justifyContent: "center",
                      position: "relative",
                      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                      backgroundColor: "rgba(0, 0, 0, 0)",
                      outline: "rgb(243, 243, 244) none 0px",
                      border: "0px none rgb(243, 243, 244)",
                      cursor: "pointer",
                      userSelect: "none",
                      verticalAlign: "middle",
                      textDecoration: "none solid rgb(243, 243, 244)",
                      fontWeight: 500,
                      minWidth: "64px",
                      borderRadius: "14px",
                      transition:
                        "background-color 0.25s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.25s cubic-bezier(0.4, 0, 0.2, 1), color 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                      color: "rgb(243, 243, 244)",
                      padding: "0px",
                      height: "58px",
                      width: "100%",
                      whiteSpace: "pre",
                    }}
                  >
                    <div
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        height: "58px",
                      }}
                    >
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          boxSizing: "border-box",
                          height: "24px",
                          width: "1.5rem",
                          fill: "rgb(243, 243, 244)",
                          flexShrink: 0,
                          margin: "8px 0px 4px",
                        }}
                      >
                        <path
                          d="M18 6H16V8H18V6Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M13 3V11H21V3H13ZM20 10H14V4H20V10Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M8 16H6V18H8V16Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M3 21H11V13H3V21ZM4 14H10V20H4V14Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M18 16H16V18H18V16Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M5 9H3V11H5V9Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M11 3H9V5H11V3Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M8 6H6V8H8V6Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M5 3H3V5H5V3Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M11 9H9V11H11V9Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M15 13H13V15H15V13Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M21 13H19V15H21V13Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M15 19H13V21H15V19Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                      <span
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          height: "22px",
                          position: "relative",
                        }}
                      >
                        <span
                          style={{
                            boxSizing: "border-box",
                            margin: "0px",
                            maxWidth: "96px",
                            fontFamily:
                              "Avenir",
                            fontSize: "11px",
                            lineHeight: "14px",
                            fontWeight: 500,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          Billets
                        </span>
                      </span>
                    </div>
                  </button>
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <button
                    type="button"
                    aria-label="Menu Offres"
                    aria-controls="tabBar-panelContent-2"
                    aria-expanded="false"
                    style={{
                      boxSizing: "border-box",
                      appearance: "button",
                      textTransform: "none",
                      overflow: "visible",
                      fontFamily: "Avenir",
                      fontSize: "14px",
                      lineHeight: "24.5px",
                      margin: "0px",
                      display: "inline-flex",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      WebkitBoxPack: "center",
                      justifyContent: "center",
                      position: "relative",
                      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                      backgroundColor: "rgba(0, 0, 0, 0)",
                      outline: "rgb(243, 243, 244) none 0px",
                      border: "0px none rgb(243, 243, 244)",
                      cursor: "pointer",
                      userSelect: "none",
                      verticalAlign: "middle",
                      textDecoration: "none solid rgb(243, 243, 244)",
                      fontWeight: 500,
                      minWidth: "64px",
                      borderRadius: "14px",
                      transition:
                        "background-color 0.25s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.25s cubic-bezier(0.4, 0, 0.2, 1), color 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                      color: "rgb(243, 243, 244)",
                      padding: "0px",
                      height: "58px",
                      width: "100%",
                      whiteSpace: "pre",
                    }}
                  >
                    <div
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        height: "58px",
                      }}
                    >
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          boxSizing: "border-box",
                          height: "24px",
                          width: "1.5rem",
                          fill: "rgb(243, 243, 244)",
                          flexShrink: 0,
                          margin: "8px 0px 4px",
                        }}
                      >
                        <path
                          d="M9 6.34003H5.47C5.25778 6.3602 5.06116 6.46029 4.92 6.62003C4.77342 6.76958 4.69132 6.97063 4.69132 7.18003C4.69132 7.38944 4.77342 7.59049 4.92 7.74003C5.0671 7.88861 5.26182 7.98066 5.47 8.00003H9C9.21318 7.97344 9.41082 7.87462 9.56 7.72003C9.70201 7.56814 9.781 7.36797 9.781 7.16003C9.781 6.9521 9.70201 6.75193 9.56 6.60003C9.41034 6.44932 9.21171 6.3571 9 6.34003Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M9 9.69003H5.47C5.25333 9.71792 5.05605 9.82911 4.92 10C4.77342 10.1496 4.69132 10.3506 4.69132 10.56C4.69132 10.7694 4.77342 10.9705 4.92 11.12C5.06116 11.2798 5.25778 11.3799 5.47 11.4H9C9.21442 11.3776 9.41341 11.2781 9.56 11.12C9.6967 10.9631 9.76862 10.7601 9.7612 10.5521C9.75377 10.3442 9.66754 10.1468 9.52 10C9.38822 9.83911 9.20423 9.72943 9 9.69003Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M5.47 13C5.29834 12.9992 5.13064 13.0516 4.99 13.15C4.84528 13.2374 4.73027 13.3663 4.66 13.52C4.5936 13.6744 4.57622 13.8454 4.6102 14.0099C4.64418 14.1745 4.72789 14.3246 4.85 14.44C4.97916 14.5673 5.14374 14.6525 5.32217 14.6846C5.50061 14.7168 5.68458 14.6942 5.85 14.62C6.00968 14.5608 6.14631 14.4522 6.24 14.31C6.33813 14.1768 6.39073 14.0155 6.39 13.85C6.39074 13.7374 6.36801 13.6259 6.32324 13.5226C6.27847 13.4193 6.21266 13.3265 6.13 13.25C6.04356 13.1646 5.94017 13.0982 5.82649 13.0551C5.71281 13.012 5.59137 12.9933 5.47 13Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M9 13H8.09C7.97125 12.9755 7.84875 12.9755 7.73 13C7.6146 13.0385 7.50644 13.0959 7.41 13.17C7.32043 13.2509 7.24888 13.3497 7.2 13.46C7.14893 13.5662 7.12162 13.6822 7.12 13.8C7.12027 13.918 7.14764 14.0343 7.2 14.14C7.24888 14.2504 7.32043 14.3492 7.41 14.43C7.5014 14.5117 7.61119 14.57 7.73 14.6C7.84875 14.6246 7.97125 14.6246 8.09 14.6H9C9.21442 14.5776 9.41341 14.4781 9.56 14.32C9.70201 14.1681 9.781 13.968 9.781 13.76C9.781 13.5521 9.70201 13.3519 9.56 13.2C9.39989 13.0745 9.20339 13.0043 9 13Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M18.58 13H15.09C14.8768 13.0266 14.6792 13.1255 14.53 13.28C14.388 13.4319 14.309 13.6321 14.309 13.84C14.309 14.048 14.388 14.2481 14.53 14.4C14.6766 14.5581 14.8756 14.6576 15.09 14.68H18.58C18.7922 14.6599 18.9888 14.5598 19.13 14.4C19.2766 14.2505 19.3587 14.0494 19.3587 13.84C19.3587 13.6306 19.2766 13.4296 19.13 13.28C18.9859 13.1241 18.7909 13.0248 18.58 13Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M15.09 8.00003C15.2633 8.00099 15.4333 7.95242 15.58 7.86003C15.7312 7.77871 15.8531 7.65196 15.9285 7.49767C16.0038 7.34337 16.0289 7.16931 16 7.00003C15.9631 6.83416 15.8778 6.68294 15.755 6.56548C15.6322 6.44801 15.4774 6.36956 15.31 6.34003C15.1436 6.29028 14.9664 6.29028 14.8 6.34003C14.6403 6.39922 14.5037 6.50782 14.41 6.65003C14.3113 6.78623 14.2619 6.95201 14.27 7.12003C14.2699 7.23012 14.292 7.3391 14.335 7.44046C14.3779 7.54183 14.4409 7.63351 14.52 7.71003C14.6657 7.87638 14.8698 7.98023 15.09 8.00003Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M15.09 9.69003C14.8756 9.71246 14.6766 9.81196 14.53 9.97003C14.388 10.1219 14.309 10.3221 14.309 10.53C14.309 10.738 14.388 10.9381 14.53 11.09C14.6766 11.2481 14.8756 11.3476 15.09 11.37H16C16.2144 11.3476 16.4134 11.2481 16.56 11.09C16.702 10.9381 16.781 10.738 16.781 10.53C16.781 10.3221 16.702 10.1219 16.56 9.97003C16.4134 9.81196 16.2144 9.71246 16 9.69003H15.09Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M17 7.81003C17.0889 7.88934 17.1903 7.95353 17.3 8.00003C17.4187 8.02513 17.5413 8.02513 17.66 8.00003H18.53C18.7409 7.97529 18.9359 7.87598 19.08 7.72003C19.2266 7.57049 19.3087 7.36944 19.3087 7.16003C19.3087 6.95063 19.2266 6.74958 19.08 6.60003C18.9388 6.44029 18.7422 6.3402 18.53 6.32003H17.66C17.5413 6.29494 17.4187 6.29494 17.3 6.32003C17.1812 6.35007 17.0714 6.4084 16.98 6.49003C16.8904 6.5709 16.8189 6.6697 16.77 6.78003C16.7176 6.88574 16.6903 7.00207 16.69 7.12003C16.6916 7.23784 16.7189 7.35387 16.77 7.46003C16.8167 7.59387 16.8957 7.7141 17 7.81003Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M18.53 9.69003C18.3567 9.68908 18.1867 9.73765 18.04 9.83003C17.8924 9.91845 17.7769 10.0515 17.71 10.21C17.6386 10.3631 17.621 10.5357 17.66 10.7C17.6915 10.8655 17.7757 11.0164 17.9 11.13C18.0232 11.2506 18.1802 11.3308 18.35 11.36C18.5164 11.4098 18.6936 11.4098 18.86 11.36C19.0251 11.2847 19.1618 11.1586 19.25 11C19.3398 10.8596 19.3883 10.6967 19.39 10.53C19.3912 10.4198 19.3697 10.3104 19.3267 10.2089C19.2836 10.1074 19.2201 10.0158 19.14 9.94003C19.0598 9.86029 18.9646 9.79716 18.8599 9.75426C18.7552 9.71136 18.6431 9.68954 18.53 9.69003Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M21.41 3.57003C21.0334 3.20177 20.5267 2.99695 20 3.00003H15.6C14.8585 2.99906 14.1301 3.19582 13.49 3.57003C12.8612 3.94104 12.3459 4.47707 12 5.12003C11.6541 4.47707 11.1388 3.94104 10.51 3.57003C9.86986 3.19582 9.1415 2.99906 8.4 3.00003H4C3.47328 2.99695 2.9666 3.20177 2.59 3.57003C2.40339 3.74606 2.25478 3.95841 2.15331 4.19402C2.05185 4.42962 1.99967 4.68351 2 4.94003V17C2.00141 17.2563 2.05437 17.5096 2.15573 17.745C2.25709 17.9804 2.40478 18.1929 2.59 18.37C2.97775 18.7147 3.48129 18.9004 4 18.89H7.62C8.47516 18.8961 9.30714 19.1688 10 19.67L10.65 20.14L11.24 20.71C11.3369 20.8013 11.4485 20.8757 11.57 20.93C11.8216 21.0235 12.0984 21.0235 12.35 20.93C12.4715 20.8757 12.5831 20.8013 12.68 20.71L13.27 20.14L13.93 19.67C14.6339 19.1608 15.4812 18.8877 16.35 18.89H20C20.5276 18.8921 21.0358 18.6917 21.42 18.33C21.7808 17.9803 21.9891 17.5024 22 17V5.00003C22.0087 4.73346 21.9606 4.46809 21.8589 4.22154C21.7572 3.97499 21.6042 3.7529 21.41 3.57003ZM11.41 19.46L10.62 18.89C9.74962 18.2503 8.70013 17.9005 7.62 17.89H4C3.73562 17.8942 3.48034 17.7936 3.29 17.61C3.1211 17.4497 3.01776 17.2323 3 17V5.00003C2.99851 4.87129 3.02348 4.74362 3.07336 4.62493C3.12325 4.50623 3.19699 4.39905 3.29 4.31003C3.38178 4.21373 3.49185 4.13671 3.61376 4.08348C3.73568 4.03025 3.86699 4.00188 4 4.00003H8.4C9.1968 3.99393 9.96455 4.29888 10.54 4.85003C10.8202 5.11306 11.0437 5.43058 11.1967 5.78311C11.3498 6.13563 11.4292 6.51572 11.43 6.90003L11.41 19.46ZM21 17C21.0001 17.1271 20.9745 17.2529 20.9247 17.3697C20.8748 17.4866 20.8018 17.5922 20.71 17.68C20.5197 17.8636 20.2644 17.9642 20 17.96H16.4C15.3199 17.9705 14.2704 18.3203 13.4 18.96L12.6 19.53V6.87003C12.6076 6.49417 12.6902 6.12362 12.843 5.78015C12.9959 5.43669 13.2158 5.12725 13.49 4.87003C14.0548 4.31878 14.8108 4.00707 15.6 4.00003H20C20.2644 3.99583 20.5197 4.09651 20.71 4.28003C20.803 4.36905 20.8768 4.47623 20.9266 4.59493C20.9765 4.71362 21.0015 4.84129 21 4.97003V17Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                      <span
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          height: "22px",
                          position: "relative",
                        }}
                      >
                        <span
                          style={{
                            boxSizing: "border-box",
                            margin: "0px",
                            maxWidth: "96px",
                            fontFamily:
                              "Avenir",
                            fontSize: "11px",
                            lineHeight: "14px",
                            fontWeight: 500,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          Offres
                        </span>
                      </span>
                    </div>
                  </button>
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <button
                    type="button"
                    aria-label="Accédez aux rubriques du compte"
                    aria-controls="tabBar-panelContent-3"
                    aria-expanded="false"
                    style={{
                      boxSizing: "border-box",
                      appearance: "button",
                      textTransform: "none",
                      overflow: "visible",
                      fontFamily: "Avenir",
                      fontSize: "14px",
                      lineHeight: "24.5px",
                      margin: "0px",
                      display: "inline-flex",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      WebkitBoxPack: "center",
                      justifyContent: "center",
                      position: "relative",
                      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                      backgroundColor: "rgba(0, 0, 0, 0)",
                      outline: "rgb(243, 243, 244) none 0px",
                      border: "0px none rgb(243, 243, 244)",
                      cursor: "pointer",
                      userSelect: "none",
                      verticalAlign: "middle",
                      textDecoration: "none solid rgb(243, 243, 244)",
                      fontWeight: 500,
                      minWidth: "64px",
                      borderRadius: "14px",
                      transition:
                        "background-color 0.25s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.25s cubic-bezier(0.4, 0, 0.2, 1), color 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                      color: "rgb(243, 243, 244)",
                      padding: "0px",
                      height: "58px",
                      width: "100%",
                      whiteSpace: "pre",
                    }}
                  >
                    <div
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        height: "58px",
                      }}
                    >
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          boxSizing: "border-box",
                          height: "24px",
                          width: "1.5rem",
                          fill: "rgb(243, 243, 244)",
                          flexShrink: 0,
                          margin: "8px 0px 4px",
                        }}
                      >
                        <path
                          d="M14.2507 10.0988C14.9317 9.65003 15.4628 9.00399 15.7743 8.24522C16.0859 7.48646 16.1634 6.65033 15.9968 5.84629C15.8476 5.03646 15.4591 4.29126 14.8826 3.70878C14.3061 3.12629 13.5686 2.73381 12.7671 2.58299C11.9711 2.41824 11.1444 2.49999 10.3952 2.81754C9.86342 3.0379 9.38334 3.36855 8.98599 3.78813C8.58863 4.2077 8.28284 4.70685 8.08837 5.25332C7.89391 5.79978 7.81511 6.3814 7.85706 6.96056C7.89901 7.53973 8.06078 8.10355 8.33191 8.61559C8.60304 9.12763 8.9775 9.57648 9.43109 9.93313C9.88467 10.2898 10.4073 10.5463 10.9651 10.6861C11.523 10.8259 12.1036 10.8458 12.6696 10.7447C13.2356 10.6435 13.7742 10.4235 14.2507 10.0988ZM13.6956 4.05147C14.2053 4.39619 14.6022 4.88597 14.8361 5.45877C15.1178 6.15045 15.1443 6.92136 14.9107 7.63109C14.6771 8.34082 14.1989 8.94216 13.5633 9.32559C12.9277 9.70903 12.177 9.84904 11.4478 9.72014C10.7186 9.59123 10.0594 9.20198 9.59045 8.62329C9.12146 8.04459 8.87378 7.31494 8.89254 6.56722C8.9113 5.81951 9.19524 5.10347 9.69264 4.54953C10.1901 3.99558 10.8678 3.64057 11.6026 3.54915C12.3373 3.45774 13.0801 3.636 13.6956 4.05147Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M7.39753 15.1161C8.30094 14.1869 9.45816 13.551 10.7212 13.2899C11.9842 13.0287 13.2956 13.1542 14.4877 13.6502C15.6798 14.1462 16.6983 14.9902 17.413 16.0743C18.1278 17.1583 18.5062 18.4332 18.4999 19.7357V20.9901C18.4973 21.1245 18.4433 21.2527 18.3493 21.3477C18.2552 21.4428 18.1283 21.4974 17.9953 21.5C17.8622 21.4974 17.7354 21.4428 17.6413 21.3477C17.5472 21.2527 17.4932 21.1245 17.4906 20.9901V19.7357C17.4906 18.2644 16.9121 16.8534 15.8824 15.813C14.8528 14.7726 13.4562 14.1881 12 14.1881C10.5438 14.1881 9.14721 14.7726 8.11751 15.813C7.08782 16.8534 6.50934 18.2644 6.50934 19.7357V20.9901C6.50676 21.1245 6.45276 21.2527 6.35867 21.3477C6.26459 21.4428 6.13772 21.4974 6.00469 21.5C5.9385 21.5008 5.87288 21.4876 5.81204 21.4612C5.7512 21.4349 5.69649 21.396 5.65143 21.347C5.60295 21.3015 5.56443 21.2462 5.53836 21.1847C5.51228 21.1233 5.49923 21.0569 5.50004 20.9901V19.7357C5.5014 18.0026 6.18392 16.341 7.39753 15.1161Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                      <span
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          height: "22px",
                          position: "relative",
                        }}
                      >
                        <span
                          style={{
                            boxSizing: "border-box",
                            margin: "0px",
                            maxWidth: "96px",
                            fontFamily:
                              "Avenir",
                            fontSize: "11px",
                            lineHeight: "14px",
                            fontWeight: 500,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          Compte
                        </span>
                      </span>
                    </div>
                  </button>
                </li>
              </ul>
              <div
                style={{
                  boxSizing: "border-box",
                  backgroundColor: "rgb(141, 232, 254)",
                  borderTopLeftRadius: "48px",
                  borderTopRightRadius: "48px",
                  bottom: "0px",
                  content: '""',
                  height: "2px",
                  position: "absolute",
                  width: "100%",
                  left: "0px",
                  opacity: 0,
                  pointerEvents: "none",
                }}
              ></div>
            </nav>
          </div>
          <div style={{ display: "none", boxSizing: "border-box" }}>
            <div
              style={{
                boxSizing: "border-box",
                backgroundColor: "rgb(12, 19, 31)",
                height: "64px",
                minWidth: "100%",
                position: "absolute",
                zIndex: 1201,
              }}
            ></div>
            <div
              data-test="navBar-header"
              style={{
                zIndex: 1202,
                boxSizing: "border-box",
                backgroundColor: "rgb(12, 19, 31)",
                bottom: "0px",
                height: "58px",
                left: "0px",
                position: "fixed",
                right: "0px",
              }}
            >
              <div
                style={{
                  boxSizing: "border-box",
                  width: "100%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                  paddingLeft: "16px",
                  paddingRight: "16px",
                }}
              >
                <div
                  style={{
                    boxSizing: "border-box",
                    display: "grid",
                    gridTemplateColumns: "1fr auto 1fr",
                    height: "100%",
                  }}
                >
                  <a
                    aria-label="Retour à l'accueil SNCF Connect"
                    href="/"
                    style={{
                      boxSizing: "border-box",
                      backgroundColor: "rgba(0, 0, 0, 0)",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      color: "rgb(141, 232, 254)",
                      textDecoration: "none solid rgb(141, 232, 254)",
                      cursor: "pointer",
                      position: "relative",
                      display: "flex",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      WebkitBoxPack: "center",
                      justifyContent: "center",
                      width: "fit-content",
                    }}
                  >
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 130 64"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ boxSizing: "border-box", height: "48px" }}
                    >
                      <path
                        d="M33.593 11.955H10.276C4.594 11.955 0 16.575 0 22.255a10.268 10.268 0 0 0 10.276 10.276h23.317A10.268 10.268 0 0 0 43.87 22.256c0-5.682-4.595-10.3-10.276-10.3ZM4.57 42.288c-.89 0-1.804.321-1.804 1.21 0 .865.865 1.063 2.421 1.433 1.655.395 3.607 1.136 3.607 3.36 0 2.717-2.224 3.73-4.669 3.73-1.235 0-2.643-.347-3.507-1.014-.494-.37-.618-.79-.618-1.111 0-.642.494-1.186 1.16-1.186.297 0 .594.1.964.37.643.52 1.359.791 2.15.791.814 0 1.827-.32 1.827-1.334 0-.938-.89-1.185-2.593-1.58-1.655-.396-3.31-1.063-3.31-3.187 0-2.495 2.223-3.557 4.446-3.557 1.111 0 2.297.272 3.087.865.544.395.667.765.667 1.087 0 .617-.444 1.136-1.136 1.136-.247 0-.519-.099-.815-.321-.593-.494-1.21-.692-1.877-.692Zm6.644-.519c0-1.26.914-1.457 1.334-1.457.42 0 1.334.198 1.334 1.457v.544h.05c.493-1.112 1.827-2.125 3.457-2.125 2.915 0 4.126 2.224 4.126 4.52v5.633c0 1.333-.94 1.556-1.409 1.556-.469 0-1.407-.223-1.407-1.556v-4.842c0-1.334-.297-2.989-2.1-2.989-1.779 0-2.618 1.532-2.618 3.039v4.792c0 1.333-.939 1.556-1.408 1.556-.47 0-1.408-.223-1.408-1.556v-8.572h.05Zm21.44 7.09c.717 0 1.137.543 1.137 1.111 0 .395-.124.79-.741 1.235-.79.568-2.026.815-2.989.815-3.335 0-5.953-2.198-5.953-5.903 0-3.631 2.692-5.904 5.978-5.904 1.062 0 2.149.247 2.94.79.641.445.79.89.79 1.211 0 .617-.47 1.21-1.21 1.21-.248 0-.52-.074-.94-.37a2.678 2.678 0 0 0-1.58-.519c-2.05 0-3.063 1.828-3.063 3.582 0 1.754.988 3.557 3.063 3.557.617 0 1.16-.149 1.655-.47.37-.247.667-.346.914-.346Zm4.1-6.102c-1.061 0-1.259-.74-1.259-1.111 0-.37.198-1.112 1.26-1.112h1.062V38.88c0-2.667 1.038-5.063 4.273-5.063 1.161 0 1.779.395 1.779 1.235 0 .617-.42 1.136-1.31 1.136-1.506 0-1.95.963-1.95 2.52v1.827h1.53c1.063 0 1.26.741 1.26 1.112 0 .37-.197 1.111-1.26 1.111h-1.53v7.584c0 1.333-.94 1.556-1.409 1.556-.444 0-1.408-.223-1.408-1.556v-7.584h-1.037Z"
                        fill="#8DE8FE"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M56.121 11.955a10.268 10.268 0 0 0-10.275 10.276A10.268 10.268 0 0 0 56.12 32.507 10.268 10.268 0 0 0 66.397 22.23 10.268 10.268 0 0 0 56.12 11.955ZM54.392 48.858c.716 0 1.136.544 1.136 1.112 0 .395-.124.79-.741 1.235-.79.568-2.026.815-2.99.815-3.334 0-5.977-2.198-5.977-5.928 0-3.631 2.717-5.928 6.003-5.928 1.062 0 2.149.246 2.939.79.642.445.79.89.79 1.21 0 .618-.469 1.21-1.21 1.21-.247 0-.519-.073-.938-.37a2.678 2.678 0 0 0-1.581-.519c-2.05 0-3.088 1.853-3.088 3.582 0 1.754.988 3.557 3.088 3.557.617 0 1.16-.148 1.655-.47.37-.172.666-.296.913-.296Zm8.768 3.187c-3.384 0-6.076-2.446-6.076-5.978 0-3.532 2.717-5.879 6.076-5.879 3.384 0 6.077 2.347 6.077 5.879 0 3.508-2.693 5.978-6.077 5.978Zm0-9.584c-2.223 0-3.235 1.852-3.235 3.581 0 1.754 1.037 3.631 3.235 3.631 2.223 0 3.236-1.877 3.236-3.63 0-1.73-1.037-3.582-3.236-3.582Zm8.473-.692c0-1.26.914-1.482 1.334-1.482.42 0 1.333.198 1.333 1.482v.544h.05c.494-1.112 1.828-2.125 3.483-2.125 2.914 0 4.125 2.248 4.125 4.52v5.657c0 1.334-.939 1.556-1.408 1.556-.47 0-1.408-.222-1.408-1.556v-4.841c0-1.334-.297-2.99-2.1-2.99-1.778 0-2.618 1.532-2.618 3.039v4.817c0 1.334-.939 1.556-1.408 1.556-.47 0-1.408-.222-1.408-1.556v-8.62h.025Zm13.091 0c0-1.26.914-1.482 1.334-1.482.42 0 1.334.198 1.334 1.482v.544h.05c.493-1.112 1.827-2.125 3.482-2.125 2.915 0 4.125 2.248 4.125 4.52v5.657c0 1.334-.939 1.556-1.408 1.556-.47 0-1.408-.222-1.408-1.556v-4.841c0-1.334-.296-2.99-2.1-2.99-1.778 0-2.618 1.532-2.618 3.039v4.817c0 1.334-.938 1.556-1.407 1.556-.47 0-1.409-.222-1.409-1.556v-8.62h.025Zm15.414 5.237c.123 1.58 1.556 2.742 3.186 2.742 1.161 0 1.877-.371 2.569-.964.395-.321.642-.395.963-.395.618 0 1.112.444 1.112 1.111 0 .223-.099.643-.47 1.013-1.086 1.038-2.346 1.507-4.149 1.507-3.459 0-6.027-2.223-6.027-5.854 0-3.606 2.544-6.002 5.928-6.002 2.717 0 4.891 1.531 5.335 4.816.025.223.05.395.05.593 0 .988-.544 1.408-1.458 1.408h-7.039v.025Zm5.73-2.026c0-1.457-.815-2.717-2.643-2.717-1.655 0-2.989 1.136-3.112 2.717h5.755Zm13.092 3.878c.716 0 1.136.544 1.136 1.112 0 .395-.124.79-.741 1.235-.791.568-2.026.815-2.989.815-3.335 0-5.978-2.198-5.978-5.928 0-3.631 2.718-5.928 6.003-5.928 1.062 0 2.149.246 2.939.79.642.445.791.89.791 1.21 0 .618-.47 1.21-1.211 1.21-.247 0-.518-.073-.938-.37a2.68 2.68 0 0 0-1.581-.519c-2.05 0-3.088 1.853-3.088 3.582 0 1.754.988 3.557 3.088 3.557.617 0 1.161-.148 1.655-.47.37-.172.667-.296.914-.296Zm8.25 3.088c-2.964 0-3.607-1.828-3.607-3.977v-5.237h-.914c-1.062 0-1.259-.74-1.259-1.111 0-.37.197-1.112 1.259-1.112h.914v-1.926c0-1.285.914-1.507 1.384-1.507.469 0 1.383.222 1.383 1.507v1.926h1.754c1.062 0 1.259.741 1.259 1.112 0 .37-.197 1.111-1.259 1.111h-1.754v5.212c0 1.087.37 1.68 1.062 1.68.124 0 .272-.025.445-.05.197-.024.222-.024.321-.024.691 0 1.062.519 1.062 1.037 0 .445-.247.815-.667 1.038a3.085 3.085 0 0 1-1.383.32Z"
                        fill="#fff"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M39.868 25.592a7.484 7.484 0 1 0-13.388-6.694 7.484 7.484 0 0 0 13.388 6.694Z"
                        fill="#0C131F"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                  </a>
                  <nav
                    aria-label="Menu principal"
                    style={{ boxSizing: "border-box" }}
                  >
                    <ul
                      role="list"
                      style={{
                        boxSizing: "border-box",
                        listStyle: "outside none none",
                        margin: "0px",
                        padding: "0px",
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fit, minmax(2rem, 1fr))",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <li style={{ boxSizing: "border-box" }}>
                        <div
                          style={{
                            boxSizing: "border-box",
                            height: "100%",
                            position: "relative",
                          }}
                        >
                          <a
                            aria-label="Voyager"
                            href="/"
                            style={{
                              boxSizing: "border-box",
                              backgroundColor: "rgba(0, 0, 0, 0)",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontSize: "13px",
                              lineHeight: "18px",
                              fontWeight: 500,
                              cursor: "pointer",
                              position: "relative",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              display: "inline-flex",
                              boxShadow: "none",
                              WebkitBoxPack: "center",
                              justifyContent: "center",
                              color: "rgb(243, 243, 244)",
                              padding: "0px",
                              height: "100%",
                              width: "100%",
                              textTransform: "none",
                              whiteSpace: "pre",
                              textDecoration: "none solid rgb(243, 243, 244)",
                            }}
                          >
                            <div
                              style={{
                                boxSizing: "border-box",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "flex",
                                flexDirection: "column",
                                height: "100%",
                              }}
                            >
                              <svg
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  boxSizing: "border-box",
                                  height: "24px",
                                  width: "1.5rem",
                                  fill: "rgb(243, 243, 244)",
                                  flexShrink: 0,
                                  margin: "8px 0px 4px",
                                }}
                              >
                                <path
                                  d="M19 15C18.2925 15.0019 17.6083 15.2538 17.0685 15.7113C16.5287 16.1688 16.168 16.8023 16.05 17.5H7.65003C6.84156 17.5297 6.0431 17.3135 5.36003 16.88C5.09371 16.6953 4.87628 16.4485 4.72647 16.1611C4.57665 15.8737 4.49895 15.5541 4.50003 15.23C4.4716 14.8369 4.53649 14.4427 4.68943 14.0795C4.84236 13.7163 5.079 13.3944 5.38003 13.14C6.04631 12.6841 6.84373 12.4593 7.65003 12.5H16C16.8515 12.4777 17.6728 12.1794 18.34 11.65C18.7372 11.2878 19.0477 10.8409 19.2485 10.3423C19.4493 9.84373 19.5353 9.30634 19.5 8.77001C19.5114 8.2984 19.4113 7.83077 19.208 7.40508C19.0048 6.97938 18.7039 6.60763 18.33 6.32001C17.55 5.76186 16.6089 5.47392 15.65 5.50001H8.00003C7.87466 4.75831 7.47523 4.09077 6.8809 3.62968C6.28656 3.1686 5.5407 2.94761 4.79111 3.01051C4.04153 3.07342 3.34293 3.41563 2.83375 3.96932C2.32458 4.52301 2.04199 5.24779 2.04199 6.00001C2.04199 6.75223 2.32458 7.477 2.83375 8.03069C3.34293 8.58438 4.04153 8.92659 4.79111 8.9895C5.5407 9.0524 6.28656 8.83142 6.8809 8.37033C7.47523 7.90924 7.87466 7.2417 8.00003 6.50001H15.7C16.4353 6.4694 17.16 6.68398 17.76 7.11001C18.0149 7.30336 18.2196 7.55501 18.3571 7.84386C18.4945 8.1327 18.5607 8.4503 18.55 8.77001C18.5817 9.15843 18.5253 9.54899 18.3851 9.91259C18.2448 10.2762 18.0243 10.6035 17.74 10.87C17.1688 11.3098 16.4602 11.533 15.74 11.5H7.74003C6.70744 11.4538 5.68938 11.7568 4.85003 12.36C4.41249 12.6961 4.06166 13.132 3.82681 13.6312C3.59197 14.1305 3.47993 14.6786 3.50003 15.23C3.49277 15.714 3.60594 16.1922 3.82937 16.6216C4.05281 17.0511 4.37949 17.4182 4.78003 17.69C5.63042 18.2492 6.63277 18.5321 7.65003 18.5H16.05C16.1454 19.0643 16.4002 19.5896 16.7844 20.0138C17.1686 20.438 17.6661 20.7435 18.2182 20.8941C18.7703 21.0448 19.354 21.0344 19.9004 20.8642C20.4468 20.694 20.9331 20.371 21.302 19.9334C21.6708 19.4958 21.9068 18.9618 21.982 18.3945C22.0573 17.8272 21.9687 17.2501 21.7267 16.7315C21.4847 16.2129 21.0994 15.7743 20.6163 15.4675C20.1331 15.1607 19.5723 14.9985 19 15ZM19 20C18.6045 20 18.2178 19.8827 17.8889 19.6629C17.56 19.4432 17.3036 19.1308 17.1523 18.7654C17.0009 18.3999 16.9613 17.9978 17.0385 17.6098C17.1156 17.2219 17.3061 16.8655 17.5858 16.5858C17.8655 16.3061 18.2219 16.1156 18.6099 16.0384C18.9978 15.9613 19.3999 16.0009 19.7654 16.1522C20.1309 16.3036 20.4432 16.56 20.663 16.8889C20.8827 17.2178 21 17.6044 21 18C21 18.5304 20.7893 19.0391 20.4142 19.4142C20.0392 19.7893 19.5305 20 19 20Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                              </svg>
                              <span
                                style={{
                                  boxSizing: "border-box",
                                  display: "flex",
                                  height: "100%",
                                  position: "relative",
                                }}
                              >
                                <span
                                  style={{
                                    boxSizing: "border-box",
                                    margin: "0px",
                                    maxWidth: "96px",
                                    fontFamily:
                                      "Avenir",
                                    fontSize: "11px",
                                    lineHeight: "14px",
                                    fontWeight: 500,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  Voyager
                                </span>
                              </span>
                            </div>
                          </a>
                          <button
                            type="button"
                            aria-controls="navBar-panelContent-0"
                            aria-expanded="false"
                            aria-label="Menu Voyager"
                            style={{
                              boxSizing: "border-box",
                              appearance: "button",
                              textTransform: "none",
                              overflow: "hidden",
                              fontFamily:
                                "Avenir",
                              fontSize: "24px",
                              lineHeight: "27.6px",
                              margin: "-1px",
                              border: "0px none rgb(243, 243, 244)",
                              clip: "rect(0px, 0px, 0px, 0px)",
                              height: "1px",
                              padding: "0px",
                              position: "absolute",
                              whiteSpace: "nowrap",
                              width: "1px",
                              display: "flex",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              WebkitBoxPack: "center",
                              justifyContent: "center",
                              WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                              backgroundColor: "rgba(0, 0, 0, 0)",
                              outline: "rgb(243, 243, 244) none 0px",
                              cursor: "pointer",
                              userSelect: "none",
                              verticalAlign: "middle",
                              textDecoration: "none solid rgb(243, 243, 244)",
                              textAlign: "center",
                              flex: "0 0 auto",
                              borderRadius: "50%",
                              color: "rgb(243, 243, 244)",
                              transition:
                                "background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                              fill: "rgb(141, 232, 254)",
                              right: "0px",
                              top: "50%",
                              transform: "none",
                            }}
                          >
                            <svg
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                boxSizing: "border-box",
                                height: "24px",
                                width: "1.5rem",
                              }}
                            >
                              <path
                                d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                            </svg>
                          </button>
                        </div>
                      </li>
                      <li style={{ boxSizing: "border-box" }}>
                        <div
                          style={{
                            boxSizing: "border-box",
                            height: "100%",
                            position: "relative",
                          }}
                        >
                          <a
                            aria-label="Billets"
                            href="/app/trips"
                            style={{
                              boxSizing: "border-box",
                              backgroundColor: "rgba(0, 0, 0, 0)",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontSize: "13px",
                              lineHeight: "18px",
                              fontWeight: 500,
                              cursor: "pointer",
                              position: "relative",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              display: "inline-flex",
                              boxShadow: "none",
                              WebkitBoxPack: "center",
                              justifyContent: "center",
                              color: "rgb(243, 243, 244)",
                              padding: "0px",
                              height: "100%",
                              width: "100%",
                              textTransform: "none",
                              whiteSpace: "pre",
                              textDecoration: "none solid rgb(243, 243, 244)",
                            }}
                          >
                            <div
                              style={{
                                boxSizing: "border-box",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "flex",
                                flexDirection: "column",
                                height: "100%",
                              }}
                            >
                              <svg
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  boxSizing: "border-box",
                                  height: "24px",
                                  width: "1.5rem",
                                  fill: "rgb(243, 243, 244)",
                                  flexShrink: 0,
                                  margin: "8px 0px 4px",
                                }}
                              >
                                <path
                                  d="M18 6H16V8H18V6Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M13 3V11H21V3H13ZM20 10H14V4H20V10Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M8 16H6V18H8V16Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M3 21H11V13H3V21ZM4 14H10V20H4V14Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M18 16H16V18H18V16Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M5 9H3V11H5V9Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M11 3H9V5H11V3Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M8 6H6V8H8V6Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M5 3H3V5H5V3Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M11 9H9V11H11V9Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M15 13H13V15H15V13Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M21 13H19V15H21V13Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M15 19H13V21H15V19Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                              </svg>
                              <span
                                style={{
                                  boxSizing: "border-box",
                                  display: "flex",
                                  height: "100%",
                                  position: "relative",
                                }}
                              >
                                <span
                                  style={{
                                    boxSizing: "border-box",
                                    margin: "0px",
                                    maxWidth: "96px",
                                    fontFamily:
                                      "Avenir",
                                    fontSize: "11px",
                                    lineHeight: "14px",
                                    fontWeight: 500,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  Billets
                                </span>
                              </span>
                            </div>
                          </a>
                          <button
                            type="button"
                            aria-controls="navBar-panelContent-1"
                            aria-expanded="false"
                            aria-label="Menu Billets"
                            style={{
                              boxSizing: "border-box",
                              appearance: "button",
                              textTransform: "none",
                              overflow: "hidden",
                              fontFamily:
                                "Avenir",
                              fontSize: "24px",
                              lineHeight: "27.6px",
                              margin: "-1px",
                              border: "0px none rgb(243, 243, 244)",
                              clip: "rect(0px, 0px, 0px, 0px)",
                              height: "1px",
                              padding: "0px",
                              position: "absolute",
                              whiteSpace: "nowrap",
                              width: "1px",
                              display: "flex",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              WebkitBoxPack: "center",
                              justifyContent: "center",
                              WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                              backgroundColor: "rgba(0, 0, 0, 0)",
                              outline: "rgb(243, 243, 244) none 0px",
                              cursor: "pointer",
                              userSelect: "none",
                              verticalAlign: "middle",
                              textDecoration: "none solid rgb(243, 243, 244)",
                              textAlign: "center",
                              flex: "0 0 auto",
                              borderRadius: "50%",
                              color: "rgb(243, 243, 244)",
                              transition:
                                "background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                              fill: "rgb(141, 232, 254)",
                              right: "0px",
                              top: "50%",
                              transform: "none",
                            }}
                          >
                            <svg
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                boxSizing: "border-box",
                                height: "24px",
                                width: "1.5rem",
                              }}
                            >
                              <path
                                d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                            </svg>
                          </button>
                        </div>
                      </li>
                      <li style={{ boxSizing: "border-box" }}>
                        <div
                          style={{
                            boxSizing: "border-box",
                            height: "100%",
                            position: "relative",
                          }}
                        >
                          <a
                            aria-label="Offres"
                            href="/app/offre"
                            style={{
                              boxSizing: "border-box",
                              backgroundColor: "rgba(0, 0, 0, 0)",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontSize: "13px",
                              lineHeight: "18px",
                              fontWeight: 500,
                              cursor: "pointer",
                              position: "relative",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              display: "inline-flex",
                              boxShadow: "none",
                              WebkitBoxPack: "center",
                              justifyContent: "center",
                              color: "rgb(243, 243, 244)",
                              padding: "0px",
                              height: "100%",
                              width: "100%",
                              textTransform: "none",
                              whiteSpace: "pre",
                              textDecoration: "none solid rgb(243, 243, 244)",
                            }}
                          >
                            <div
                              style={{
                                boxSizing: "border-box",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "flex",
                                flexDirection: "column",
                                height: "100%",
                              }}
                            >
                              <svg
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  boxSizing: "border-box",
                                  height: "24px",
                                  width: "1.5rem",
                                  fill: "rgb(243, 243, 244)",
                                  flexShrink: 0,
                                  margin: "8px 0px 4px",
                                }}
                              >
                                <path
                                  d="M9 6.34003H5.47C5.25778 6.3602 5.06116 6.46029 4.92 6.62003C4.77342 6.76958 4.69132 6.97063 4.69132 7.18003C4.69132 7.38944 4.77342 7.59049 4.92 7.74003C5.0671 7.88861 5.26182 7.98066 5.47 8.00003H9C9.21318 7.97344 9.41082 7.87462 9.56 7.72003C9.70201 7.56814 9.781 7.36797 9.781 7.16003C9.781 6.9521 9.70201 6.75193 9.56 6.60003C9.41034 6.44932 9.21171 6.3571 9 6.34003Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M9 9.69003H5.47C5.25333 9.71792 5.05605 9.82911 4.92 10C4.77342 10.1496 4.69132 10.3506 4.69132 10.56C4.69132 10.7694 4.77342 10.9705 4.92 11.12C5.06116 11.2798 5.25778 11.3799 5.47 11.4H9C9.21442 11.3776 9.41341 11.2781 9.56 11.12C9.6967 10.9631 9.76862 10.7601 9.7612 10.5521C9.75377 10.3442 9.66754 10.1468 9.52 10C9.38822 9.83911 9.20423 9.72943 9 9.69003Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M5.47 13C5.29834 12.9992 5.13064 13.0516 4.99 13.15C4.84528 13.2374 4.73027 13.3663 4.66 13.52C4.5936 13.6744 4.57622 13.8454 4.6102 14.0099C4.64418 14.1745 4.72789 14.3246 4.85 14.44C4.97916 14.5673 5.14374 14.6525 5.32217 14.6846C5.50061 14.7168 5.68458 14.6942 5.85 14.62C6.00968 14.5608 6.14631 14.4522 6.24 14.31C6.33813 14.1768 6.39073 14.0155 6.39 13.85C6.39074 13.7374 6.36801 13.6259 6.32324 13.5226C6.27847 13.4193 6.21266 13.3265 6.13 13.25C6.04356 13.1646 5.94017 13.0982 5.82649 13.0551C5.71281 13.012 5.59137 12.9933 5.47 13Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M9 13H8.09C7.97125 12.9755 7.84875 12.9755 7.73 13C7.6146 13.0385 7.50644 13.0959 7.41 13.17C7.32043 13.2509 7.24888 13.3497 7.2 13.46C7.14893 13.5662 7.12162 13.6822 7.12 13.8C7.12027 13.918 7.14764 14.0343 7.2 14.14C7.24888 14.2504 7.32043 14.3492 7.41 14.43C7.5014 14.5117 7.61119 14.57 7.73 14.6C7.84875 14.6246 7.97125 14.6246 8.09 14.6H9C9.21442 14.5776 9.41341 14.4781 9.56 14.32C9.70201 14.1681 9.781 13.968 9.781 13.76C9.781 13.5521 9.70201 13.3519 9.56 13.2C9.39989 13.0745 9.20339 13.0043 9 13Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M18.58 13H15.09C14.8768 13.0266 14.6792 13.1255 14.53 13.28C14.388 13.4319 14.309 13.6321 14.309 13.84C14.309 14.048 14.388 14.2481 14.53 14.4C14.6766 14.5581 14.8756 14.6576 15.09 14.68H18.58C18.7922 14.6599 18.9888 14.5598 19.13 14.4C19.2766 14.2505 19.3587 14.0494 19.3587 13.84C19.3587 13.6306 19.2766 13.4296 19.13 13.28C18.9859 13.1241 18.7909 13.0248 18.58 13Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M15.09 8.00003C15.2633 8.00099 15.4333 7.95242 15.58 7.86003C15.7312 7.77871 15.8531 7.65196 15.9285 7.49767C16.0038 7.34337 16.0289 7.16931 16 7.00003C15.9631 6.83416 15.8778 6.68294 15.755 6.56548C15.6322 6.44801 15.4774 6.36956 15.31 6.34003C15.1436 6.29028 14.9664 6.29028 14.8 6.34003C14.6403 6.39922 14.5037 6.50782 14.41 6.65003C14.3113 6.78623 14.2619 6.95201 14.27 7.12003C14.2699 7.23012 14.292 7.3391 14.335 7.44046C14.3779 7.54183 14.4409 7.63351 14.52 7.71003C14.6657 7.87638 14.8698 7.98023 15.09 8.00003Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M15.09 9.69003C14.8756 9.71246 14.6766 9.81196 14.53 9.97003C14.388 10.1219 14.309 10.3221 14.309 10.53C14.309 10.738 14.388 10.9381 14.53 11.09C14.6766 11.2481 14.8756 11.3476 15.09 11.37H16C16.2144 11.3476 16.4134 11.2481 16.56 11.09C16.702 10.9381 16.781 10.738 16.781 10.53C16.781 10.3221 16.702 10.1219 16.56 9.97003C16.4134 9.81196 16.2144 9.71246 16 9.69003H15.09Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M17 7.81003C17.0889 7.88934 17.1903 7.95353 17.3 8.00003C17.4187 8.02513 17.5413 8.02513 17.66 8.00003H18.53C18.7409 7.97529 18.9359 7.87598 19.08 7.72003C19.2266 7.57049 19.3087 7.36944 19.3087 7.16003C19.3087 6.95063 19.2266 6.74958 19.08 6.60003C18.9388 6.44029 18.7422 6.3402 18.53 6.32003H17.66C17.5413 6.29494 17.4187 6.29494 17.3 6.32003C17.1812 6.35007 17.0714 6.4084 16.98 6.49003C16.8904 6.5709 16.8189 6.6697 16.77 6.78003C16.7176 6.88574 16.6903 7.00207 16.69 7.12003C16.6916 7.23784 16.7189 7.35387 16.77 7.46003C16.8167 7.59387 16.8957 7.7141 17 7.81003Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M18.53 9.69003C18.3567 9.68908 18.1867 9.73765 18.04 9.83003C17.8924 9.91845 17.7769 10.0515 17.71 10.21C17.6386 10.3631 17.621 10.5357 17.66 10.7C17.6915 10.8655 17.7757 11.0164 17.9 11.13C18.0232 11.2506 18.1802 11.3308 18.35 11.36C18.5164 11.4098 18.6936 11.4098 18.86 11.36C19.0251 11.2847 19.1618 11.1586 19.25 11C19.3398 10.8596 19.3883 10.6967 19.39 10.53C19.3912 10.4198 19.3697 10.3104 19.3267 10.2089C19.2836 10.1074 19.2201 10.0158 19.14 9.94003C19.0598 9.86029 18.9646 9.79716 18.8599 9.75426C18.7552 9.71136 18.6431 9.68954 18.53 9.69003Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M21.41 3.57003C21.0334 3.20177 20.5267 2.99695 20 3.00003H15.6C14.8585 2.99906 14.1301 3.19582 13.49 3.57003C12.8612 3.94104 12.3459 4.47707 12 5.12003C11.6541 4.47707 11.1388 3.94104 10.51 3.57003C9.86986 3.19582 9.1415 2.99906 8.4 3.00003H4C3.47328 2.99695 2.9666 3.20177 2.59 3.57003C2.40339 3.74606 2.25478 3.95841 2.15331 4.19402C2.05185 4.42962 1.99967 4.68351 2 4.94003V17C2.00141 17.2563 2.05437 17.5096 2.15573 17.745C2.25709 17.9804 2.40478 18.1929 2.59 18.37C2.97775 18.7147 3.48129 18.9004 4 18.89H7.62C8.47516 18.8961 9.30714 19.1688 10 19.67L10.65 20.14L11.24 20.71C11.3369 20.8013 11.4485 20.8757 11.57 20.93C11.8216 21.0235 12.0984 21.0235 12.35 20.93C12.4715 20.8757 12.5831 20.8013 12.68 20.71L13.27 20.14L13.93 19.67C14.6339 19.1608 15.4812 18.8877 16.35 18.89H20C20.5276 18.8921 21.0358 18.6917 21.42 18.33C21.7808 17.9803 21.9891 17.5024 22 17V5.00003C22.0087 4.73346 21.9606 4.46809 21.8589 4.22154C21.7572 3.97499 21.6042 3.7529 21.41 3.57003ZM11.41 19.46L10.62 18.89C9.74962 18.2503 8.70013 17.9005 7.62 17.89H4C3.73562 17.8942 3.48034 17.7936 3.29 17.61C3.1211 17.4497 3.01776 17.2323 3 17V5.00003C2.99851 4.87129 3.02348 4.74362 3.07336 4.62493C3.12325 4.50623 3.19699 4.39905 3.29 4.31003C3.38178 4.21373 3.49185 4.13671 3.61376 4.08348C3.73568 4.03025 3.86699 4.00188 4 4.00003H8.4C9.1968 3.99393 9.96455 4.29888 10.54 4.85003C10.8202 5.11306 11.0437 5.43058 11.1967 5.78311C11.3498 6.13563 11.4292 6.51572 11.43 6.90003L11.41 19.46ZM21 17C21.0001 17.1271 20.9745 17.2529 20.9247 17.3697C20.8748 17.4866 20.8018 17.5922 20.71 17.68C20.5197 17.8636 20.2644 17.9642 20 17.96H16.4C15.3199 17.9705 14.2704 18.3203 13.4 18.96L12.6 19.53V6.87003C12.6076 6.49417 12.6902 6.12362 12.843 5.78015C12.9959 5.43669 13.2158 5.12725 13.49 4.87003C14.0548 4.31878 14.8108 4.00707 15.6 4.00003H20C20.2644 3.99583 20.5197 4.09651 20.71 4.28003C20.803 4.36905 20.8768 4.47623 20.9266 4.59493C20.9765 4.71362 21.0015 4.84129 21 4.97003V17Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                              </svg>
                              <span
                                style={{
                                  boxSizing: "border-box",
                                  display: "flex",
                                  height: "100%",
                                  position: "relative",
                                }}
                              >
                                <span
                                  style={{
                                    boxSizing: "border-box",
                                    margin: "0px",
                                    maxWidth: "96px",
                                    fontFamily:
                                      "Avenir",
                                    fontSize: "11px",
                                    lineHeight: "14px",
                                    fontWeight: 500,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  Offres
                                </span>
                              </span>
                            </div>
                          </a>
                          <button
                            type="button"
                            aria-controls="navBar-panelContent-2"
                            aria-expanded="false"
                            aria-label="Menu Offres"
                            style={{
                              boxSizing: "border-box",
                              appearance: "button",
                              textTransform: "none",
                              overflow: "hidden",
                              fontFamily:
                                "Avenir",
                              fontSize: "24px",
                              lineHeight: "27.6px",
                              margin: "-1px",
                              border: "0px none rgb(243, 243, 244)",
                              clip: "rect(0px, 0px, 0px, 0px)",
                              height: "1px",
                              padding: "0px",
                              position: "absolute",
                              whiteSpace: "nowrap",
                              width: "1px",
                              display: "flex",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              WebkitBoxPack: "center",
                              justifyContent: "center",
                              WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                              backgroundColor: "rgba(0, 0, 0, 0)",
                              outline: "rgb(243, 243, 244) none 0px",
                              cursor: "pointer",
                              userSelect: "none",
                              verticalAlign: "middle",
                              textDecoration: "none solid rgb(243, 243, 244)",
                              textAlign: "center",
                              flex: "0 0 auto",
                              borderRadius: "50%",
                              color: "rgb(243, 243, 244)",
                              transition:
                                "background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                              fill: "rgb(141, 232, 254)",
                              right: "0px",
                              top: "50%",
                              transform: "none",
                            }}
                          >
                            <svg
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                boxSizing: "border-box",
                                height: "24px",
                                width: "1.5rem",
                              }}
                            >
                              <path
                                d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                            </svg>
                          </button>
                        </div>
                      </li>
                      <li style={{ boxSizing: "border-box" }}>
                        <div
                          style={{
                            boxSizing: "border-box",
                            height: "100%",
                            position: "relative",
                          }}
                        >
                          <a
                            aria-label="Compte"
                            href="/app/account"
                            style={{
                              boxSizing: "border-box",
                              backgroundColor: "rgba(0, 0, 0, 0)",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontSize: "13px",
                              lineHeight: "18px",
                              fontWeight: 500,
                              cursor: "pointer",
                              position: "relative",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              display: "inline-flex",
                              boxShadow: "none",
                              WebkitBoxPack: "center",
                              justifyContent: "center",
                              color: "rgb(243, 243, 244)",
                              padding: "0px",
                              height: "100%",
                              width: "100%",
                              textTransform: "none",
                              whiteSpace: "pre",
                              textDecoration: "none solid rgb(243, 243, 244)",
                            }}
                          >
                            <div
                              style={{
                                boxSizing: "border-box",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "flex",
                                flexDirection: "column",
                                height: "100%",
                              }}
                            >
                              <svg
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  boxSizing: "border-box",
                                  height: "24px",
                                  width: "1.5rem",
                                  fill: "rgb(243, 243, 244)",
                                  flexShrink: 0,
                                  margin: "8px 0px 4px",
                                }}
                              >
                                <path
                                  d="M14.2507 10.0988C14.9317 9.65003 15.4628 9.00399 15.7743 8.24522C16.0859 7.48646 16.1634 6.65033 15.9968 5.84629C15.8476 5.03646 15.4591 4.29126 14.8826 3.70878C14.3061 3.12629 13.5686 2.73381 12.7671 2.58299C11.9711 2.41824 11.1444 2.49999 10.3952 2.81754C9.86342 3.0379 9.38334 3.36855 8.98599 3.78813C8.58863 4.2077 8.28284 4.70685 8.08837 5.25332C7.89391 5.79978 7.81511 6.3814 7.85706 6.96056C7.89901 7.53973 8.06078 8.10355 8.33191 8.61559C8.60304 9.12763 8.9775 9.57648 9.43109 9.93313C9.88467 10.2898 10.4073 10.5463 10.9651 10.6861C11.523 10.8259 12.1036 10.8458 12.6696 10.7447C13.2356 10.6435 13.7742 10.4235 14.2507 10.0988ZM13.6956 4.05147C14.2053 4.39619 14.6022 4.88597 14.8361 5.45877C15.1178 6.15045 15.1443 6.92136 14.9107 7.63109C14.6771 8.34082 14.1989 8.94216 13.5633 9.32559C12.9277 9.70903 12.177 9.84904 11.4478 9.72014C10.7186 9.59123 10.0594 9.20198 9.59045 8.62329C9.12146 8.04459 8.87378 7.31494 8.89254 6.56722C8.9113 5.81951 9.19524 5.10347 9.69264 4.54953C10.1901 3.99558 10.8678 3.64057 11.6026 3.54915C12.3373 3.45774 13.0801 3.636 13.6956 4.05147Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                                <path
                                  d="M7.39753 15.1161C8.30094 14.1869 9.45816 13.551 10.7212 13.2899C11.9842 13.0287 13.2956 13.1542 14.4877 13.6502C15.6798 14.1462 16.6983 14.9902 17.413 16.0743C18.1278 17.1583 18.5062 18.4332 18.4999 19.7357V20.9901C18.4973 21.1245 18.4433 21.2527 18.3493 21.3477C18.2552 21.4428 18.1283 21.4974 17.9953 21.5C17.8622 21.4974 17.7354 21.4428 17.6413 21.3477C17.5472 21.2527 17.4932 21.1245 17.4906 20.9901V19.7357C17.4906 18.2644 16.9121 16.8534 15.8824 15.813C14.8528 14.7726 13.4562 14.1881 12 14.1881C10.5438 14.1881 9.14721 14.7726 8.11751 15.813C7.08782 16.8534 6.50934 18.2644 6.50934 19.7357V20.9901C6.50676 21.1245 6.45276 21.2527 6.35867 21.3477C6.26459 21.4428 6.13772 21.4974 6.00469 21.5C5.9385 21.5008 5.87288 21.4876 5.81204 21.4612C5.7512 21.4349 5.69649 21.396 5.65143 21.347C5.60295 21.3015 5.56443 21.2462 5.53836 21.1847C5.51228 21.1233 5.49923 21.0569 5.50004 20.9901V19.7357C5.5014 18.0026 6.18392 16.341 7.39753 15.1161Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                              </svg>
                              <span
                                style={{
                                  boxSizing: "border-box",
                                  display: "flex",
                                  height: "100%",
                                  position: "relative",
                                }}
                              >
                                <span
                                  style={{
                                    boxSizing: "border-box",
                                    margin: "0px",
                                    maxWidth: "96px",
                                    fontFamily:
                                      "Avenir",
                                    fontSize: "11px",
                                    lineHeight: "14px",
                                    fontWeight: 500,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  Compte
                                </span>
                              </span>
                            </div>
                          </a>
                          <button
                            type="button"
                            aria-controls="navBar-panelContent-3"
                            aria-expanded="false"
                            aria-label="Accédez aux rubriques du compte"
                            style={{
                              boxSizing: "border-box",
                              appearance: "button",
                              textTransform: "none",
                              overflow: "hidden",
                              fontFamily:
                                "Avenir",
                              fontSize: "24px",
                              lineHeight: "27.6px",
                              margin: "-1px",
                              border: "0px none rgb(243, 243, 244)",
                              clip: "rect(0px, 0px, 0px, 0px)",
                              height: "1px",
                              padding: "0px",
                              position: "absolute",
                              whiteSpace: "nowrap",
                              width: "1px",
                              display: "flex",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              WebkitBoxPack: "center",
                              justifyContent: "center",
                              WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                              backgroundColor: "rgba(0, 0, 0, 0)",
                              outline: "rgb(243, 243, 244) none 0px",
                              cursor: "pointer",
                              userSelect: "none",
                              verticalAlign: "middle",
                              textDecoration: "none solid rgb(243, 243, 244)",
                              textAlign: "center",
                              flex: "0 0 auto",
                              borderRadius: "50%",
                              color: "rgb(243, 243, 244)",
                              transition:
                                "background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                              fill: "rgb(141, 232, 254)",
                              right: "0px",
                              top: "50%",
                              transform: "none",
                            }}
                          >
                            <svg
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                boxSizing: "border-box",
                                height: "24px",
                                width: "1.5rem",
                              }}
                            >
                              <path
                                d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                            </svg>
                          </button>
                        </div>
                      </li>
                    </ul>
                  </nav>
                  <div
                    style={{
                      boxSizing: "border-box",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      display: "flex",
                      WebkitBoxPack: "end",
                      justifyContent: "flex-end",
                    }}
                  ></div>
                </div>
              </div>
              <div
                style={{
                  boxSizing: "border-box",
                  backgroundColor: "rgb(141, 232, 254)",
                  borderTopLeftRadius: "48px",
                  borderTopRightRadius: "48px",
                  bottom: "0px",
                  content: '""',
                  height: "2px",
                  position: "absolute",
                  width: "100%",
                  left: "0px",
                  opacity: 0,
                  pointerEvents: "none",
                }}
              ></div>
            </div>
            <div
              aria-hidden="true"
              style={{
                opacity: 0,
                boxSizing: "border-box",
                position: "fixed",
                display: "flex",
                WebkitBoxAlign: "center",
                alignItems: "center",
                WebkitBoxPack: "center",
                justifyContent: "center",
                inset: "0px",
                WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                backgroundColor: "rgba(70, 77, 94, 0.7)",
                backdropFilter: "blur(2px)",
                zIndex: 1200,
              }}
            ></div>
          </div>
        </header>
        <div
          style={{
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            paddingBottom: "58px",
          }}
        >
          <main
            role="main"
            style={{
              boxSizing: "border-box",
              flex: "1 1 0%",
              display: "flex",
              flexDirection: "column",
              minHeight: "800px",
            }}
          >
            <div
              style={{
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                WebkitBoxFlex: 1,
                flexGrow: 1,
              }}
            >
              <div style={{ boxSizing: "border-box" }}>
                <header
                  style={{
                    boxSizing: "border-box",
                    transition: "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    boxShadow: "none",
                    backgroundImage:
                      "linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0))",
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    flexShrink: 0,
                    position: "sticky",
                    zIndex: 1100,
                    top: "0px",
                    left: "auto",
                    right: "0px",
                    backgroundColor: "rgb(12, 19, 31)",
                    color: "rgb(243, 243, 244)",
                    height: "56px",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    padding: "16px 0px",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      width: "100%",
                      marginLeft: "auto",
                      marginRight: "auto",
                      display: "block",
                      padding: "0px 16px",
                    }}
                  >
                    <div
                      style={{
                        height: "24px",
                        boxSizing: "border-box",
                        minHeight: "0px",
                        padding: "0px",
                        position: "relative",
                        display: "flex",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        paddingLeft: "0px",
                        paddingRight: "0px",
                      }}
                    >
                      <button
                        type="button"
                        aria-label="Retourner vers la page précédente"
                        data-test="back-button"
                        data-cs-override-id="fleche_retour"
                        style={{
                          boxSizing: "border-box",
                          appearance: "button",
                          textTransform: "none",
                          overflow: "visible",
                          fontFamily:
                            "Avenir",
                          fontSize: "24px",
                          lineHeight: "27.6px",
                          margin: "0px 16px 0px 0px",
                          display: "flex",
                          WebkitBoxAlign: "center",
                          alignItems: "center",
                          WebkitBoxPack: "center",
                          justifyContent: "center",
                          position: "relative",
                          WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                          outline: "rgb(38, 52, 65) none 0px",
                          border: "0px none rgb(38, 52, 65)",
                          cursor: "pointer",
                          userSelect: "none",
                          verticalAlign: "middle",
                          textDecoration: "none solid rgb(38, 52, 65)",
                          textAlign: "center",
                          flex: "0 0 auto",
                          borderRadius: "50%",
                          transition:
                            "background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                          alignSelf: "auto",
                          backgroundColor: "rgb(243, 243, 244)",
                          color: "rgb(38, 52, 65)",
                          padding: "8px",
                          height: "32px",
                          width: "2rem",
                        }}
                      >
                        <svg
                          aria-hidden="true"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            boxSizing: "border-box",
                            fill: "rgb(12, 19, 31)",
                          }}
                        >
                          <path
                            d="M20.0156 11.0156V12.9844H7.82812L13.4062 18.6094L12 20.0156L3.98438 12L12 3.98438L13.4062 5.39062L7.82812 11.0156H20.0156Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </button>
                      <h1
                        style={{
                          boxSizing: "border-box",
                          fontSize: "18px",
                          margin: "0px",
                          fontFamily:
                            "Avenir",
                          lineHeight: "24px",
                          fontWeight: 800,
                          WebkitBoxFlex: 1,
                          flexGrow: 1,
                        }}
                      >
                        Cartes et abonnements SNCF
                      </h1>
                    </div>
                  </div>
                </header>
                <div
                  style={{
                    boxSizing: "border-box",
                    backgroundColor: "rgb(243, 243, 248)",
                    minHeight: "100%",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      padding: "0px",
                      width: "100%",
                      marginLeft: "auto",
                      marginRight: "auto",
                      display: "block",
                      paddingLeft: "0px",
                      paddingRight: "0px",
                      height: "auto",
                    }}
                  >
                    <div
                      style={{
                        boxSizing: "border-box",
                        display: "flex",
                        flexFlow: "row wrap",
                        width: "100%",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        height: "",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          margin: "0px",
                          flexDirection: "row",
                          flexBasis: "100%",
                          WebkitBoxFlex: 0,
                          flexGrow: 0,
                          maxWidth: "100%",
                          padding: "0px 16px",
                        }}
                      >
                        <div
                          data-test="breadcrumb"
                          style={{
                            boxSizing: "border-box",
                            margin: "24px 0px 0px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                            color: "rgb(94, 104, 120)",
                            padding: "0px",
                          }}
                        >
                          <ol
                            style={{
                              boxSizing: "border-box",
                              display: "flex",
                              flexWrap: "wrap",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              padding: "0px",
                              margin: "0px",
                              listStyle: "outside none none",
                            }}
                          >
                            <li style={{ boxSizing: "border-box" }}>
                              <a
                                href="/"
                                style={{
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  fontWeight: 500,
                                  color: "rgb(20, 112, 138)",
                                  textDecoration:
                                    "none solid rgb(20, 112, 138)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  padding: "0px",
                                }}
                              >
                                Accueil
                              </a>
                            </li>
                            <li
                              aria-hidden="true"
                              style={{
                                boxSizing: "border-box",
                                display: "flex",
                                userSelect: "none",
                                marginLeft: "8px",
                                marginRight: "8px",
                              }}
                            >
                              <svg
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  boxSizing: "border-box",
                                  height: "13px",
                                  margin: "2px -8px 0px",
                                  width: "1.25rem",
                                }}
                              >
                                <path
                                  d="M8.79362 6.6659C8.36568 7.06175 8.36568 7.73825 8.79362 8.1341L12.973 12L8.79362 15.8659C8.36568 16.2617 8.36568 16.9383 8.79362 17.3341L8.83447 17.3719C9.21775 17.7264 9.80928 17.7264 10.1926 17.3719L15.2064 12.7341C15.6343 12.3383 15.6343 11.6617 15.2064 11.2659L10.1926 6.62811C9.80928 6.27358 9.21775 6.27358 8.83447 6.62811L8.79362 6.6659Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                              </svg>
                            </li>
                            <li style={{ boxSizing: "border-box" }}>
                              <a
                                href="/app/offre"
                                style={{
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  fontWeight: 500,
                                  color: "rgb(20, 112, 138)",
                                  textDecoration:
                                    "none solid rgb(20, 112, 138)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  padding: "0px",
                                }}
                              >
                                Offres
                              </a>
                            </li>
                            <li
                              aria-hidden="true"
                              style={{
                                boxSizing: "border-box",
                                display: "flex",
                                userSelect: "none",
                                marginLeft: "8px",
                                marginRight: "8px",
                              }}
                            >
                              <svg
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  boxSizing: "border-box",
                                  height: "13px",
                                  margin: "2px -8px 0px",
                                  width: "1.25rem",
                                }}
                              >
                                <path
                                  d="M8.79362 6.6659C8.36568 7.06175 8.36568 7.73825 8.79362 8.1341L12.973 12L8.79362 15.8659C8.36568 16.2617 8.36568 16.9383 8.79362 17.3341L8.83447 17.3719C9.21775 17.7264 9.80928 17.7264 10.1926 17.3719L15.2064 12.7341C15.6343 12.3383 15.6343 11.6617 15.2064 11.2659L10.1926 6.62811C9.80928 6.27358 9.21775 6.27358 8.83447 6.62811L8.79362 6.6659Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                              </svg>
                            </li>
                            <li style={{ boxSizing: "border-box" }}>
                              <p
                                aria-current="page"
                                style={{
                                  boxSizing: "border-box",
                                  margin: "2px 0px 0px",
                                  fontFamily:
                                    "Avenir",
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  fontWeight: 500,
                                  color: "rgb(12, 19, 31)",
                                }}
                              >
                                Cartes et abonnements
                              </p>
                            </li>
                          </ol>
                        </div>
                        <ul
                          style={{
                            boxSizing: "border-box",
                            listStyle: "outside none none",
                            padding: "0px",
                            display: "grid",
                            gap: "24px",
                            gridTemplateColumns: "393px",
                            margin: "16px 0px 48px",
                          }}
                        >
                          {mobileOffers.map((offer) => (
                            <AbonnementCard {...offer as Offer}  />
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                boxSizing: "border-box",
                backgroundColor: "rgb(243, 243, 248)",
                minHeight: "100%",
              }}
            >
              <div
                style={{
                  boxSizing: "border-box",
                  padding: "0px",
                  width: "100%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                  paddingLeft: "0px",
                  paddingRight: "0px",
                  height: "auto",
                }}
              >
                <div
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexFlow: "row wrap",
                    width: "100%",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    height: "340px",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      flexDirection: "row",
                      flexBasis: "100%",
                      WebkitBoxFlex: 0,
                      flexGrow: 0,
                      maxWidth: "100%",
                      padding: "0px 16px",
                    }}
                  >
                    <div
                      aria-label="Besoin d’aide ?"
                      role="region"
                      style={{
                        boxSizing: "border-box",
                        color: "rgb(12, 19, 31)",
                        transition:
                          "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        borderRadius: "14px",
                        overflow: "hidden",
                        boxShadow: "none",
                        border: "0px none rgb(12, 19, 31)",
                        background:
                          "rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box",
                        display: "flex",
                        justifyContent: "space-evenly",
                        padding: "24px",
                        margin: "32px 0px",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          flexFlow: "row wrap",
                          width: "100%",
                          WebkitBoxPack: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            margin: "0px",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            padding: "0px",
                          }}
                        >
                          <div
                            style={{
                              boxSizing: "border-box",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              display: "flex",
                              flexDirection: "column",
                              WebkitBoxPack: "center",
                              justifyContent: "center",
                              padding: "0px",
                            }}
                          >
                            <svg
                              aria-hidden="true"
                              viewBox="0 0 80 80"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                boxSizing: "border-box",
                                height: "80px",
                                width: "5rem",
                              }}
                            >
                              <path
                                d="M40 78C60.9868 78 78 60.9868 78 40C78 19.0132 60.9868 2 40 2C19.0132 2 2 19.0132 2 40C2 60.9868 19.0132 78 40 78Z"
                                fill="#127996"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M39.9996 72.8101C58.1201 72.8101 72.8097 58.1205 72.8097 40C72.8097 21.8794 58.1201 7.18985 39.9996 7.18985C21.879 7.18985 7.18945 21.8794 7.18945 40C7.18945 58.1205 21.879 72.8101 39.9996 72.8101Z"
                                fill="white"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M57.3988 45.029C60.0345 45.029 62.1712 43.9608 62.1712 42.6428C62.1712 41.3249 60.0345 40.2567 57.3988 40.2567C54.763 40.2567 52.6265 41.3249 52.6265 42.6428C52.6265 43.9608 54.763 45.029 57.3988 45.029Z"
                                fill="#FF97C7"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M23.9916 45.029C26.6273 45.029 28.764 43.9608 28.764 42.6428C28.764 41.3249 26.6273 40.2567 23.9916 40.2567C21.3558 40.2567 19.2192 41.3249 19.2192 42.6428C19.2192 43.9608 21.3558 45.029 23.9916 45.029Z"
                                fill="#FF97C7"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M57.3986 35.4843C57.3986 36.1922 57.1886 36.8842 56.7953 37.4728C56.402 38.0615 55.843 38.5202 55.189 38.7911C54.5349 39.062 53.8153 39.1329 53.1209 38.9948C52.4266 38.8567 51.7889 38.5158 51.2883 38.0152C50.7877 37.5146 50.4468 36.8768 50.3087 36.1825C50.1707 35.4882 50.2416 34.7685 50.5125 34.1145C50.7834 33.4604 51.2422 32.9014 51.8308 32.5082C52.4195 32.1149 53.1115 31.905 53.8194 31.905C54.2894 31.905 54.7549 31.9976 55.1891 32.1775C55.6234 32.3573 56.0179 32.621 56.3503 32.9534C56.6827 33.2857 56.9463 33.6803 57.1261 34.1146C57.306 34.5488 57.3986 35.0143 57.3986 35.4843Z"
                                fill="#0C131F"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M31.1505 35.4843C31.1505 36.1922 30.9406 36.8842 30.5473 37.4728C30.154 38.0615 29.595 38.5202 28.9409 38.7911C28.2869 39.062 27.5672 39.1329 26.8729 38.9948C26.1786 38.8567 25.5408 38.5158 25.0402 38.0152C24.5397 37.5146 24.1988 36.8768 24.0607 36.1825C23.9226 35.4882 23.9935 34.7685 24.2644 34.1145C24.5354 33.4604 24.9942 32.9014 25.5828 32.5082C26.1714 32.1149 26.8634 31.905 27.5714 31.905C28.0414 31.905 28.5068 31.9976 28.9411 32.1775C29.3753 32.3573 29.7699 32.621 30.1023 32.9534C30.4346 33.2857 30.6982 33.6803 30.8781 34.1146C31.058 34.5488 31.1505 35.0143 31.1505 35.4843Z"
                                fill="#0C131F"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M47.0512 44.5783C46.9316 44.4747 46.7758 44.4228 46.618 44.4341C46.4602 44.4454 46.3133 44.5189 46.2097 44.6385C45.1053 45.9131 43.0799 46.8188 40.6953 46.8188C38.3102 46.8188 36.2848 45.9131 35.1804 44.6385C35.1291 44.5793 35.0667 44.5308 34.9966 44.4957C34.9266 44.4606 34.8503 44.4397 34.7722 44.4341C34.694 44.4285 34.6155 44.4384 34.5412 44.4631C34.4669 44.4879 34.3982 44.527 34.3389 44.5783C34.2797 44.6296 34.2312 44.6921 34.1962 44.7621C34.1611 44.8322 34.1402 44.9084 34.1346 44.9866C34.129 45.0647 34.1388 45.1432 34.1636 45.2175C34.1883 45.2918 34.2275 45.3606 34.2788 45.4198C35.6538 47.0066 38.0375 48.0119 40.6953 48.0119C43.3527 48.0119 45.7365 47.0066 47.1114 45.4198C47.2149 45.3002 47.2668 45.1444 47.2555 44.9866C47.2443 44.8288 47.1708 44.6819 47.0512 44.5783Z"
                                fill="#0C131F"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                            </svg>
                            <p
                              style={{
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "16px",
                                lineHeight: "22px",
                                fontWeight: 500,
                                paddingBottom: "8px",
                                paddingTop: "16px",
                                textAlign: "center",
                              }}
                            >
                              Besoin d’aide ?
                            </p>
                            <p
                              style={{
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "16px",
                                lineHeight: "22px",
                                fontWeight: 500,
                                paddingBottom: "32px",
                                textAlign: "center",
                              }}
                            >
                              Trouvons la réponse qui vous convient
                            </p>
                          </div>
                          <button
                            type="button"
                            aria-describedby="botHelpDescription"
                            data-test="bot-link"
                            style={{
                              boxSizing: "border-box",
                              appearance: "button",
                              textTransform: "none",
                              overflow: "visible",
                              fontFamily:
                                "Avenir",
                              fontSize: "16px",
                              lineHeight: "22px",
                              margin: "0px",
                              display: "flex",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              WebkitBoxPack: "center",
                              justifyContent: "center",
                              position: "relative",
                              WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                              outline: "rgb(20, 112, 138) none 0px",
                              cursor: "pointer",
                              userSelect: "none",
                              verticalAlign: "middle",
                              textDecoration: "none solid rgb(20, 112, 138)",
                              transition:
                                "background-color 0.25s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.25s cubic-bezier(0.4, 0, 0.2, 1), color 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                              border: "1px solid rgb(20, 112, 138)",
                              width: "100%",
                              background:
                                "rgba(0, 0, 0, 0) none repeat scroll 0% 0% / auto padding-box border-box",
                              color: "rgb(20, 112, 138)",
                              borderRadius: "24px",
                              padding: "8px 24px",
                              whiteSpace: "break-spaces",
                              fontWeight: 500,
                              maxWidth: "288px",
                              minHeight: "48px",
                              minWidth: "156px",
                            }}
                          >
                            Lancer la conversation
                            <span
                              style={{
                                boxSizing: "border-box",
                                overflow: "hidden",
                                pointerEvents: "none",
                                position: "absolute",
                                zIndex: 0,
                                inset: "0px",
                                borderRadius: "24px",
                              }}
                            ></span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <footer role="contentinfo" style={{ boxSizing: "border-box" }}>
            <div
              style={{
                boxSizing: "border-box",
                backgroundColor: "rgb(12, 19, 31)",
                minHeight: "100%",
                color: "rgb(243, 243, 244)",
                padding: "24px 0px",
              }}
            >
              <div
                style={{
                  boxSizing: "border-box",
                  padding: "0px",
                  width: "100%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                  paddingLeft: "0px",
                  paddingRight: "0px",
                  height: "auto",
                }}
              >
                <div
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexFlow: "row wrap",
                    width: "100%",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    height: "2494px",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      flexDirection: "row",
                      flexBasis: "100%",
                      WebkitBoxFlex: 0,
                      flexGrow: 0,
                      maxWidth: "100%",
                      padding: "0px 16px",
                    }}
                  >
                    <div
                      style={{
                        boxSizing: "border-box",
                        margin: "24px 0px 16px",
                      }}
                    >
                      <div
                        style={{ boxSizing: "border-box", marginTop: "24px" }}
                      >
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 8px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Nos engagements
                        </p>
                        <ul
                          style={{
                            boxSizing: "border-box",
                            listStyle: "outside none none",
                            margin: "0px",
                            padding: "0px",
                          }}
                        >
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <a
                              href="/tgv-inoui/tarifs"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Meilleurs prix garantis
                            </a>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <a
                              href="/aide/le-paiement-securise-et-authentifie"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Paiement sécurisé
                            </a>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <button
                              role="link"
                              style={{
                                boxSizing: "border-box",
                                appearance: "none",
                                textTransform: "none",
                                overflow: "visible",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                margin: "0px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                outline: "rgb(157, 160, 165) none 0px",
                                border: "0px none rgb(157, 160, 165)",
                                borderRadius: "0px",
                                userSelect: "none",
                                verticalAlign: "middle",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Contact 7j/7
                            </button>
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <a
                              href="/train/elu-service-client-annee"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Service client de l'année 2024
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div
                        style={{ boxSizing: "border-box", marginTop: "24px" }}
                      >
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 8px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Moyens de paiement
                        </p>
                        <ul
                          style={{
                            boxSizing: "border-box",
                            listStyle: "outside none none",
                            margin: "0px",
                            display: "grid",
                            gap: "8px",
                            gridTemplateColumns: "repeat(auto-fill, 1.875rem)",
                            lineHeight: "0px",
                            padding: "8px 0px",
                          }}
                        >
                          <li style={{ boxSizing: "border-box" }}>
                            <img
                              src="/assets/media/2021-11/cb.png"
                              alt="CB"
                              style={{
                                boxSizing: "border-box",
                                borderStyle: "none",
                                height: "30px",
                                width: "1.875rem",
                              }}
                            />
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <img
                              src="/assets/media/2021-11/visa.png"
                              alt="Visa"
                              style={{
                                boxSizing: "border-box",
                                borderStyle: "none",
                                height: "30px",
                                width: "1.875rem",
                              }}
                            />
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <img
                              src="/assets/media/2021-11/mastercard.png"
                              alt="Mastercard"
                              style={{
                                boxSizing: "border-box",
                                borderStyle: "none",
                                height: "30px",
                                width: "1.875rem",
                              }}
                            />
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <img
                              src="/assets/media/2021-11/amex.png"
                              alt="American Express"
                              style={{
                                boxSizing: "border-box",
                                borderStyle: "none",
                                height: "30px",
                                width: "1.875rem",
                              }}
                            />
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <img
                              src="/assets/media/2022-11/apple-pay.png"
                              alt="Apple Pay"
                              style={{
                                boxSizing: "border-box",
                                borderStyle: "none",
                                height: "30px",
                                width: "1.875rem",
                              }}
                            />
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <img
                              src="/assets/media/2022-05/ancv_0.png"
                              alt="ANCV"
                              style={{
                                boxSizing: "border-box",
                                borderStyle: "none",
                                height: "30px",
                                width: "1.875rem",
                              }}
                            />
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <img
                              src="/assets/media/2023-08/alma_logo.png"
                              alt="Alma"
                              style={{
                                boxSizing: "border-box",
                                borderStyle: "none",
                                height: "30px",
                                width: "1.875rem",
                              }}
                            />
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <button
                              role="link"
                              title="Ayvens"
                              style={{
                                boxSizing: "border-box",
                                appearance: "none",
                                textTransform: "none",
                                overflow: "visible",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                margin: "0px",
                                fontWeight: 500,
                                color: "rgb(141, 232, 254)",
                                textDecoration: "none solid rgb(141, 232, 254)",
                                WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                outline: "rgb(141, 232, 254) none 0px",
                                border: "0px none rgb(141, 232, 254)",
                                borderRadius: "0px",
                                padding: "0px",
                                userSelect: "none",
                                verticalAlign: "middle",
                                cursor: "pointer",
                                position: "relative",
                                display: "inline-flex",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                WebkitBoxPack: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                src="/assets/media/2024-05/logo-ayvens-light-format-footer.png"
                                alt="Ayvens"
                                style={{
                                  boxSizing: "border-box",
                                  borderStyle: "none",
                                  height: "30px",
                                  width: "1.875rem",
                                }}
                              />
                            </button>
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <button
                              role="link"
                              title="Betterway"
                              style={{
                                boxSizing: "border-box",
                                appearance: "none",
                                textTransform: "none",
                                overflow: "visible",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                margin: "0px",
                                fontWeight: 500,
                                color: "rgb(141, 232, 254)",
                                textDecoration: "none solid rgb(141, 232, 254)",
                                WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                outline: "rgb(141, 232, 254) none 0px",
                                border: "0px none rgb(141, 232, 254)",
                                borderRadius: "0px",
                                padding: "0px",
                                userSelect: "none",
                                verticalAlign: "middle",
                                cursor: "pointer",
                                position: "relative",
                                display: "inline-flex",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                WebkitBoxPack: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                src="/assets/media/2023-04/betterway.png"
                                alt="Betterway"
                                style={{
                                  boxSizing: "border-box",
                                  borderStyle: "none",
                                  height: "30px",
                                  width: "1.875rem",
                                }}
                              />
                            </button>
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <button
                              role="link"
                              title="Pluxee"
                              style={{
                                boxSizing: "border-box",
                                appearance: "none",
                                textTransform: "none",
                                overflow: "visible",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                margin: "0px",
                                fontWeight: 500,
                                color: "rgb(141, 232, 254)",
                                textDecoration: "none solid rgb(141, 232, 254)",
                                WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                outline: "rgb(141, 232, 254) none 0px",
                                border: "0px none rgb(141, 232, 254)",
                                borderRadius: "0px",
                                padding: "0px",
                                userSelect: "none",
                                verticalAlign: "middle",
                                cursor: "pointer",
                                position: "relative",
                                display: "inline-flex",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                WebkitBoxPack: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                src="/assets/media/2024-01/pluxee_0.png"
                                alt="Pluxee"
                                style={{
                                  boxSizing: "border-box",
                                  borderStyle: "none",
                                  height: "30px",
                                  width: "1.875rem",
                                }}
                              />
                            </button>
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <button
                              role="link"
                              title="RoadMate"
                              style={{
                                boxSizing: "border-box",
                                appearance: "none",
                                textTransform: "none",
                                overflow: "visible",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                margin: "0px",
                                fontWeight: 500,
                                color: "rgb(141, 232, 254)",
                                textDecoration: "none solid rgb(141, 232, 254)",
                                WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                outline: "rgb(141, 232, 254) none 0px",
                                border: "0px none rgb(141, 232, 254)",
                                borderRadius: "0px",
                                padding: "0px",
                                userSelect: "none",
                                verticalAlign: "middle",
                                cursor: "pointer",
                                position: "relative",
                                display: "inline-flex",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                WebkitBoxPack: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                src="/assets/media/2023-04/roadmate_0.png"
                                alt="RoadMate"
                                style={{
                                  boxSizing: "border-box",
                                  borderStyle: "none",
                                  height: "30px",
                                  width: "1.875rem",
                                }}
                              />
                            </button>
                          </li>
                        </ul>
                        <ul
                          role="list"
                          style={{
                            boxSizing: "border-box",
                            listStyle: "outside none none",
                            margin: "24px 0px 0px",
                            padding: "0px",
                          }}
                        >
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <a
                              href="/aide/le-paiement-de-vos-billets-de-train-modes-de-paiement-acceptes"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Infos et conditions
                            </a>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <a
                              href="https://www.sncf-connect.com/cheque-vacances-connect"
                              target="_blank"
                              title="Paiement en Chèque-Vacances Connect - Nouvel Onglet"
                              rel="noopener noreferrer"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Paiement en Chèque-Vacances Connect
                              <svg
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  boxSizing: "border-box",
                                  height: "16px",
                                  width: "1rem",
                                  alignSelf: "normal",
                                  fill: "rgb(157, 160, 165)",
                                  flexShrink: 0,
                                  marginLeft: "6px",
                                }}
                              >
                                <path
                                  d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                              </svg>
                            </a>
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <a
                              href="https://www.sncf-connect.com/bons-plans/budget-mobilite?prex=homepage_footer"
                              target="_blank"
                              title="Infos et conditions de paiement avec les cartes Ayvens, Betterway, Pluxee, RoadMate, Swile ou Worklife - Nouvel Onglet"
                              rel="noopener noreferrer"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Infos et conditions de paiement avec les cartes
                              Ayvens, Betterway, Pluxee, RoadMate, Swile ou
                              Worklife
                              <svg
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  boxSizing: "border-box",
                                  height: "16px",
                                  width: "1rem",
                                  alignSelf: "normal",
                                  fill: "rgb(157, 160, 165)",
                                  flexShrink: 0,
                                  marginLeft: "6px",
                                }}
                              >
                                <path
                                  d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                              </svg>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div
                        style={{ boxSizing: "border-box", marginTop: "24px" }}
                      >
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 8px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Choix du pays
                        </p>
                        <div
                          style={{
                            boxSizing: "border-box",
                            maxWidth: "410px",
                            padding: "8px 0px",
                          }}
                        >
                          <div
                            style={{
                              boxSizing: "border-box",
                              display: "inline-flex",
                              flexDirection: "column",
                              position: "relative",
                              minWidth: "0px",
                              padding: "0px",
                              margin: "0px",
                              border: "0px none rgb(243, 243, 244)",
                              verticalAlign: "top",
                              width: "100%",
                            }}
                          >
                            <label
                              data-shrink="true"
                              style={{
                                boxSizing: "border-box",
                                color: "rgb(243, 243, 244)",
                                transform: "matrix(0.96, 0, 0, 0.96, 14, -6)",
                                padding: "0px",
                                display: "block",
                                transformOrigin: "0px 0px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "calc(133% - 24px)",
                                position: "absolute",
                                left: "0px",
                                top: "0px",
                                transition:
                                  "color 0.2s cubic-bezier(0, 0, 0.2, 1), transform 0.2s cubic-bezier(0, 0, 0.2, 1), max-width 0.2s cubic-bezier(0, 0, 0.2, 1)",
                                zIndex: 1,
                                pointerEvents: "auto",
                                userSelect: "none",
                                fontFamily:
                                  "Avenir",
                                fontSize: "16px",
                                lineHeight: "22px",
                                fontWeight: 500,
                              }}
                            >
                              <p
                                style={{
                                  boxSizing: "border-box",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  fontWeight: 500,
                                }}
                              >
                                Langue
                              </p>
                            </label>
                            <div
                              style={{
                                boxSizing: "border-box",
                                fontFamily:
                                  "Avenir",
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "23px",
                                color: "rgb(243, 243, 244)",
                                cursor: "text",
                                display: "flex",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                position: "relative",
                                borderRadius: "8px",
                                maxHeight: "56px",
                              }}
                            >
                              <div
                                role="button"
                                aria-expanded="false"
                                aria-haspopup="listbox"
                                aria-labelledby="footer-language-selector-label footer-language-selector"
                                style={{
                                  boxSizing: "content-box",
                                  height: "auto",
                                  minHeight: "23px",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  paddingRight: "32px",
                                  appearance: "none",
                                  userSelect: "none",
                                  borderRadius: "14px",
                                  cursor: "pointer",
                                  fontStyle: "normal",
                                  fontVariant: "normal",
                                  fontStretch: "100%",
                                  fontOpticalSizing: "auto",
                                  fontSizeAdjust: "none",
                                  fontKerning: "auto",
                                  fontFeatureSettings: "normal",
                                  fontVariationSettings: "normal",
                                  letterSpacing: "normal",
                                  color: "rgb(243, 243, 244)",
                                  border: "0px none rgb(243, 243, 244)",
                                  margin: "0px",
                                  WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                  display: "block",
                                  minWidth: "0px",
                                  width: "100%",
                                  animationName: "mui-auto-fill-cancel",
                                  animationDuration: "0.01s",
                                  padding: "16.5px 32px 16.5px 14px",
                                  fontFamily:
                                    "Avenir",
                                  fontSize: "16px",
                                  lineHeight: "22px",
                                  fontWeight: 500,
                                }}
                              >
                                <div
                                  style={{
                                    boxSizing: "content-box",
                                    WebkitBoxAlign: "center",
                                    alignItems: "center",
                                    display: "flex",
                                  }}
                                >
                                  <img
                                    alt=""
                                    src="/app/flag-icons/FR.svg"
                                    style={{
                                      boxSizing: "content-box",
                                      borderStyle: "none",
                                      borderRadius: "2px",
                                      height: "14px",
                                      width: "1.25rem",
                                    }}
                                  />
                                  <p
                                    style={{
                                      boxSizing: "content-box",
                                      marginLeft: "10px",
                                      margin: "0px 0px 0px 10px",
                                      fontFamily:
                                        "Avenir",
                                      fontSize: "16px",
                                      lineHeight: "22px",
                                      fontWeight: 500,
                                    }}
                                  >
                                    France
                                  </p>
                                </div>
                              </div>
                              <input
                                aria-hidden="true"
                                value="fr-fr"
                                style={{
                                  boxSizing: "border-box",
                                  overflow: "clip",
                                  fontFamily:
                                    "Avenir",
                                  fontSize: "16px",
                                  lineHeight: "18.4px",
                                  margin: "0px",
                                  bottom: "0px",
                                  left: "0px",
                                  position: "absolute",
                                  opacity: 0,
                                  pointerEvents: "none",
                                  width: "100%",
                                }}
                              />
                              <svg
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  boxSizing: "border-box",
                                  position: "absolute",
                                  right: "7px",
                                  top: "16px",
                                  pointerEvents: "none",
                                  color: "rgb(243, 243, 244)",
                                  fill: "rgb(141, 232, 254)",
                                  width: "1.5rem",
                                }}
                              >
                                <path
                                  d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                              </svg>
                              <fieldset
                                aria-hidden="true"
                                style={{
                                  boxSizing: "border-box",
                                  padding: "0px 8px",
                                  textAlign: "left",
                                  position: "absolute",
                                  inset: "-5px 0px 0px",
                                  margin: "0px",
                                  pointerEvents: "none",
                                  borderRadius: "8px",
                                  borderStyle: "solid",
                                  borderWidth: "1px",
                                  overflow: "hidden",
                                  minWidth: "0%",
                                  borderColor: "rgb(165, 172, 188)",
                                  border: "1px solid rgb(165, 172, 188)",
                                }}
                              >
                                <legend
                                  style={{
                                    boxSizing: "border-box",
                                    color: "rgb(243, 243, 244)",
                                    display: "block",
                                    maxWidth: "100%",
                                    padding: "0px",
                                    whiteSpace: "nowrap",
                                    float: "none",
                                    width: "auto",
                                    overflow: "hidden",
                                    height: "11px",
                                    fontSize: "12px",
                                    visibility: "hidden",
                                    transition:
                                      "max-width 0.1s cubic-bezier(0, 0, 0.2, 1) 0.05s",
                                  }}
                                >
                                  <span
                                    style={{
                                      boxSizing: "border-box",
                                      paddingLeft: "5px",
                                      paddingRight: "5px",
                                      display: "inline-block",
                                      opacity: 0,
                                      visibility: "visible",
                                    }}
                                  >
                                    Langue
                                  </span>
                                </legend>
                              </fieldset>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr
                      aria-hidden="true"
                      style={{
                        boxSizing: "content-box",
                        height: "2px",
                        overflow: "visible",
                        margin: "0px",
                        flexShrink: 0,
                        borderWidth: "0px",
                        borderColor: "rgb(173, 255, 47)",
                        backgroundColor: "rgb(36, 43, 53)",
                        borderStyle: "none",
                      }}
                    />
                    <div
                      style={{
                        boxSizing: "border-box",
                        margin: "24px 0px 16px",
                      }}
                    >
                      <div style={{ boxSizing: "border-box" }}>
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 8px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Nos partenaires
                        </p>
                        <ul
                          style={{
                            boxSizing: "border-box",
                            listStyle: "outside none none",
                            margin: "0px",
                            padding: "0px",
                            display: "flex",
                            flexWrap: "wrap",
                            maxWidth: "calc(100% - 8px)",
                          }}
                        >
                          <li style={{ boxSizing: "border-box" }}>
                            <a
                              href="/train/services-train/assurance-allianz-travel"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                color: "rgb(141, 232, 254)",
                                textDecoration: "none solid rgb(141, 232, 254)",
                                cursor: "pointer",
                                position: "relative",
                                display: "inline-flex",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                WebkitBoxPack: "center",
                                justifyContent: "center",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              <img
                                src="/assets/media/2021-11/allianz_eagle_travel_50x150_pixels_negative_footer.png"
                                alt="Allianz Travel"
                                style={{
                                  boxSizing: "border-box",
                                  borderStyle: "none",
                                  height: "36px",
                                }}
                              />
                            </a>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginLeft: "24px",
                            }}
                          >
                            <a
                              href="http://www.railteam.fr"
                              target="_blank"
                              title="Railteam - Nouvel Onglet"
                              rel="noopener noreferrer"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                color: "rgb(141, 232, 254)",
                                textDecoration: "none solid rgb(141, 232, 254)",
                                cursor: "pointer",
                                position: "relative",
                                display: "inline-flex",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                WebkitBoxPack: "center",
                                justifyContent: "center",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              <img
                                src="/assets/media/2021-11/railteam.png"
                                alt="Railteam"
                                style={{
                                  boxSizing: "border-box",
                                  borderStyle: "none",
                                  height: "36px",
                                }}
                              />
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div
                        style={{ boxSizing: "border-box", marginTop: "24px" }}
                      >
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 8px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Suivez-nous !
                        </p>
                        <ul
                          role="list"
                          style={{
                            boxSizing: "border-box",
                            listStyle: "outside none none",
                            margin: "0px",
                            padding: "0px",
                            display: "grid",
                            gap: "16px",
                            gridTemplateColumns: "repeat(auto-fill, 2rem)",
                          }}
                        >
                          <li style={{ boxSizing: "border-box" }}>
                            <a
                              href="https://www.instagram.com/sncfconnect/"
                              target="_blank"
                              title="Instagram - Nouvel Onglet"
                              rel="noopener noreferrer"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                color: "rgb(141, 232, 254)",
                                textDecoration: "none solid rgb(141, 232, 254)",
                                cursor: "pointer",
                                position: "relative",
                                display: "inline-flex",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                WebkitBoxPack: "center",
                                justifyContent: "center",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              <img
                                src="/assets/media/2022-01/instagram_outline_12.svg"
                                alt="Instagram"
                                style={{
                                  boxSizing: "border-box",
                                  borderStyle: "none",
                                  height: "32px",
                                  width: "2rem",
                                }}
                              />
                            </a>
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <a
                              href="https://www.tiktok.com/@sncfconnect"
                              target="_blank"
                              title="TikTok - Nouvel Onglet"
                              rel="noopener noreferrer"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                color: "rgb(141, 232, 254)",
                                textDecoration: "none solid rgb(141, 232, 254)",
                                cursor: "pointer",
                                position: "relative",
                                display: "inline-flex",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                WebkitBoxPack: "center",
                                justifyContent: "center",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              <img
                                src="/assets/media/2022-01/tiktok_outline.svg"
                                alt="TikTok"
                                style={{
                                  boxSizing: "border-box",
                                  borderStyle: "none",
                                  height: "32px",
                                  width: "2rem",
                                }}
                              />
                            </a>
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <a
                              href="https://www.facebook.com/sncfconnect"
                              target="_blank"
                              title="Facebook - Nouvel Onglet"
                              rel="noopener noreferrer"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                color: "rgb(141, 232, 254)",
                                textDecoration: "none solid rgb(141, 232, 254)",
                                cursor: "pointer",
                                position: "relative",
                                display: "inline-flex",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                WebkitBoxPack: "center",
                                justifyContent: "center",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              <img
                                src="/assets/media/2023-12/facebook_outline.svg"
                                alt="Facebook"
                                style={{
                                  boxSizing: "border-box",
                                  borderStyle: "none",
                                  height: "32px",
                                  width: "2rem",
                                }}
                              />
                            </a>
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <a
                              href="https://twitter.com/sncfconnect"
                              target="_blank"
                              title="X, anciennement Twitter - Nouvel Onglet"
                              rel="noopener noreferrer"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                color: "rgb(141, 232, 254)",
                                textDecoration: "none solid rgb(141, 232, 254)",
                                cursor: "pointer",
                                position: "relative",
                                display: "inline-flex",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                WebkitBoxPack: "center",
                                justifyContent: "center",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              <img
                                src="/assets/media/2023-09/x_outline.svg"
                                alt="X, anciennement Twitter"
                                style={{
                                  boxSizing: "border-box",
                                  borderStyle: "none",
                                  height: "32px",
                                  width: "2rem",
                                }}
                              />
                            </a>
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <a
                              href="https://www.pinterest.fr/sncfconnect/"
                              target="_blank"
                              title="Pinterest - Nouvel Onglet"
                              rel="noopener noreferrer"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                color: "rgb(141, 232, 254)",
                                textDecoration: "none solid rgb(141, 232, 254)",
                                cursor: "pointer",
                                position: "relative",
                                display: "inline-flex",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                WebkitBoxPack: "center",
                                justifyContent: "center",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              <img
                                src="/assets/media/2022-01/pinterest_outline_11.svg"
                                alt="Pinterest"
                                style={{
                                  boxSizing: "border-box",
                                  borderStyle: "none",
                                  height: "32px",
                                  width: "2rem",
                                }}
                              />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <hr
                      aria-hidden="true"
                      style={{
                        boxSizing: "content-box",
                        height: "2px",
                        overflow: "visible",
                        margin: "0px",
                        flexShrink: 0,
                        borderWidth: "0px",
                        borderColor: "rgb(173, 255, 47)",
                        backgroundColor: "rgb(36, 43, 53)",
                        borderStyle: "none",
                      }}
                    />
                    <div
                      style={{
                        boxSizing: "border-box",
                        margin: "24px 0px 16px",
                      }}
                    >
                      <div
                        style={{ boxSizing: "border-box", marginTop: "24px" }}
                      >
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 8px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          L'entreprise
                        </p>
                        <ul
                          style={{
                            boxSizing: "border-box",
                            listStyle: "outside none none",
                            margin: "0px",
                            padding: "0px",
                          }}
                        >
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <a
                              href="/conditions-generales-presentation-offres-agence"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Conditions de présentation des offres sur le site
                            </a>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <button
                              role="link"
                              style={{
                                boxSizing: "border-box",
                                appearance: "none",
                                textTransform: "none",
                                overflow: "visible",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                margin: "0px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                outline: "rgb(157, 160, 165) none 0px",
                                border: "0px none rgb(157, 160, 165)",
                                borderRadius: "0px",
                                userSelect: "none",
                                verticalAlign: "middle",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Conditions générales de vente
                            </button>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <a
                              href="/aide/droits-des-voyageurs-ferroviaires"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Droits des voyageurs ferroviaires et Règlement
                              européen n°2021/782
                            </a>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <a
                              href="/informations-legales"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Informations légales
                            </a>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <button
                              role="link"
                              style={{
                                boxSizing: "border-box",
                                appearance: "none",
                                textTransform: "none",
                                overflow: "visible",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                margin: "0px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                outline: "rgb(157, 160, 165) none 0px",
                                border: "0px none rgb(157, 160, 165)",
                                borderRadius: "0px",
                                userSelect: "none",
                                verticalAlign: "middle",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Charte de confidentialité et cookies
                            </button>
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <a
                              href="/app/account/consentManagement"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Gestion des cookies
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div
                        style={{ boxSizing: "border-box", marginTop: "24px" }}
                      >
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 8px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Partenariat
                        </p>
                        <ul
                          style={{
                            boxSizing: "border-box",
                            listStyle: "outside none none",
                            margin: "0px",
                            padding: "0px",
                          }}
                        >
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <a
                              href="/outils/regie-ouiad"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Régie publicitaire
                            </a>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <a
                              href="/outils/partenaire-affiliation"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Devenir partenaire ou affilié
                            </a>
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <button
                              role="link"
                              style={{
                                boxSizing: "border-box",
                                appearance: "none",
                                textTransform: "none",
                                overflow: "visible",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                margin: "0px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                outline: "rgb(157, 160, 165) none 0px",
                                border: "0px none rgb(157, 160, 165)",
                                borderRadius: "0px",
                                userSelect: "none",
                                verticalAlign: "middle",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Widget SNCF Connect
                            </button>
                          </li>
                        </ul>
                      </div>
                      <div
                        style={{ boxSizing: "border-box", marginTop: "24px" }}
                      >
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 8px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Sites du groupe
                        </p>
                        <ul
                          style={{
                            boxSizing: "border-box",
                            listStyle: "outside none none",
                            margin: "0px",
                            padding: "0px",
                          }}
                        >
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <a
                              href="https://presse.vous.sncf-connect.com/"
                              target="_blank"
                              title="Espace Presse SNCF Connect &amp; Tech - Nouvel Onglet"
                              rel="noopener noreferrer"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Espace Presse SNCF Connect &amp; Tech
                              <svg
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  boxSizing: "border-box",
                                  height: "16px",
                                  width: "1rem",
                                  alignSelf: "normal",
                                  fill: "rgb(157, 160, 165)",
                                  flexShrink: 0,
                                  marginLeft: "6px",
                                }}
                              >
                                <path
                                  d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                              </svg>
                            </a>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <a
                              href="https://jobs.connect-tech.sncf/"
                              target="_blank"
                              title="Carrières SNCF Connect &amp; Tech - Nouvel Onglet"
                              rel="noopener noreferrer"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Carrières SNCF Connect &amp; Tech
                              <svg
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  boxSizing: "border-box",
                                  height: "16px",
                                  width: "1rem",
                                  alignSelf: "normal",
                                  fill: "rgb(157, 160, 165)",
                                  flexShrink: 0,
                                  marginLeft: "6px",
                                }}
                              >
                                <path
                                  d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                              </svg>
                            </a>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <button
                              role="link"
                              style={{
                                boxSizing: "border-box",
                                appearance: "none",
                                textTransform: "none",
                                overflow: "visible",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                margin: "0px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                outline: "rgb(157, 160, 165) none 0px",
                                border: "0px none rgb(157, 160, 165)",
                                borderRadius: "0px",
                                userSelect: "none",
                                verticalAlign: "middle",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Le compte des agents SNCF
                            </button>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <button
                              role="link"
                              style={{
                                boxSizing: "border-box",
                                appearance: "none",
                                textTransform: "none",
                                overflow: "visible",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                margin: "0px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                outline: "rgb(157, 160, 165) none 0px",
                                border: "0px none rgb(157, 160, 165)",
                                borderRadius: "0px",
                                userSelect: "none",
                                verticalAlign: "middle",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Groupe-sncf.com
                              <svg
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  boxSizing: "border-box",
                                  height: "16px",
                                  width: "1rem",
                                  alignSelf: "normal",
                                  fill: "rgb(157, 160, 165)",
                                  flexShrink: 0,
                                  marginLeft: "6px",
                                }}
                              >
                                <path
                                  d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                              </svg>
                            </button>
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <button
                              role="link"
                              style={{
                                boxSizing: "border-box",
                                appearance: "none",
                                textTransform: "none",
                                overflow: "visible",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                margin: "0px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                outline: "rgb(157, 160, 165) none 0px",
                                border: "0px none rgb(157, 160, 165)",
                                borderRadius: "0px",
                                userSelect: "none",
                                verticalAlign: "middle",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Emploi Groupe SNCF
                              <svg
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  boxSizing: "border-box",
                                  height: "16px",
                                  width: "1rem",
                                  alignSelf: "normal",
                                  fill: "rgb(157, 160, 165)",
                                  flexShrink: 0,
                                  marginLeft: "6px",
                                }}
                              >
                                <path
                                  d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                              </svg>
                            </button>
                          </li>
                        </ul>
                      </div>
                      <div
                        style={{ boxSizing: "border-box", marginTop: "24px" }}
                      >
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 8px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Vous informer
                        </p>
                        <ul
                          style={{
                            boxSizing: "border-box",
                            listStyle: "outside none none",
                            margin: "0px",
                            padding: "0px",
                          }}
                        >
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <button
                              role="link"
                              style={{
                                boxSizing: "border-box",
                                appearance: "none",
                                textTransform: "none",
                                overflow: "visible",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                margin: "0px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                outline: "rgb(157, 160, 165) none 0px",
                                border: "0px none rgb(157, 160, 165)",
                                borderRadius: "0px",
                                userSelect: "none",
                                verticalAlign: "middle",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Aide
                            </button>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <button
                              role="link"
                              style={{
                                boxSizing: "border-box",
                                appearance: "none",
                                textTransform: "none",
                                overflow: "visible",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                margin: "0px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                outline: "rgb(157, 160, 165) none 0px",
                                border: "0px none rgb(157, 160, 165)",
                                borderRadius: "0px",
                                userSelect: "none",
                                verticalAlign: "middle",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Contactez-nous
                            </button>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <button
                              role="link"
                              style={{
                                boxSizing: "border-box",
                                appearance: "none",
                                textTransform: "none",
                                overflow: "visible",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                margin: "0px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                outline: "rgb(157, 160, 165) none 0px",
                                border: "0px none rgb(157, 160, 165)",
                                borderRadius: "0px",
                                userSelect: "none",
                                verticalAlign: "middle",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Vos billets
                            </button>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <a
                              href="https://vous.sncf-connect.com"
                              target="_blank"
                              title="Communauté SNCF Connect - Nouvel Onglet"
                              rel="noopener noreferrer"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Communauté SNCF Connect
                              <svg
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  boxSizing: "border-box",
                                  height: "16px",
                                  width: "1rem",
                                  alignSelf: "normal",
                                  fill: "rgb(157, 160, 165)",
                                  flexShrink: 0,
                                  marginLeft: "6px",
                                }}
                              >
                                <path
                                  d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                              </svg>
                            </a>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <a
                              href="/plan-du-site"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Plan du site SNCF Connect
                            </a>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <a
                              href="/services-train/guide-voyageur"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Guide du voyageur
                            </a>
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <button
                              role="link"
                              style={{
                                boxSizing: "border-box",
                                appearance: "none",
                                textTransform: "none",
                                overflow: "visible",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                margin: "0px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                outline: "rgb(157, 160, 165) none 0px",
                                border: "0px none rgb(157, 160, 165)",
                                borderRadius: "0px",
                                userSelect: "none",
                                verticalAlign: "middle",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Franchissement frontière
                            </button>
                          </li>
                        </ul>
                      </div>
                      <div
                        style={{ boxSizing: "border-box", marginTop: "24px" }}
                      >
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 8px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Handicap &amp; mobilité réduite
                        </p>
                        <ul
                          style={{
                            boxSizing: "border-box",
                            listStyle: "outside none none",
                            margin: "0px",
                            padding: "0px",
                          }}
                        >
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <a
                              href="/accessibilite"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Accessibilité numérique : conformité partielle
                            </a>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <button
                              role="link"
                              style={{
                                boxSizing: "border-box",
                                appearance: "none",
                                textTransform: "none",
                                overflow: "visible",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                margin: "0px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                outline: "rgb(157, 160, 165) none 0px",
                                border: "0px none rgb(157, 160, 165)",
                                borderRadius: "0px",
                                userSelect: "none",
                                verticalAlign: "middle",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Préparez votre voyage sur SNCF Connect
                            </button>
                          </li>
                          <li
                            style={{
                              boxSizing: "border-box",
                              marginBottom: "8px",
                            }}
                          >
                            <a
                              href="https://www.garesetconnexions.sncf/fr/service-client/service-assistance-gare-PMR"
                              target="_blank"
                              title="Tout savoir sur le service d'assistance en gare - Nouvel Onglet"
                              rel="noopener noreferrer"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Tout savoir sur le service d'assistance en gare
                              <svg
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  boxSizing: "border-box",
                                  height: "16px",
                                  width: "1rem",
                                  alignSelf: "normal",
                                  fill: "rgb(157, 160, 165)",
                                  flexShrink: 0,
                                  marginLeft: "6px",
                                }}
                              >
                                <path
                                  d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                              </svg>
                            </a>
                          </li>
                          <li style={{ boxSizing: "border-box" }}>
                            <a
                              href="https://railprmassistance.uic.org/"
                              target="_blank"
                              title="Les autres services d'assistance en Europe - Nouvel Onglet"
                              rel="noopener noreferrer"
                              style={{
                                boxSizing: "border-box",
                                backgroundColor: "rgba(0, 0, 0, 0)",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "13px",
                                lineHeight: "18px",
                                fontWeight: 500,
                                textDecoration: "none solid rgb(157, 160, 165)",
                                cursor: "pointer",
                                position: "relative",
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "inline-flex",
                                color: "rgb(157, 160, 165)",
                                textAlign: "left",
                                padding: "8px 0px",
                                width: "fit-content",
                              }}
                            >
                              Les autres services d'assistance en Europe
                              <svg
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  boxSizing: "border-box",
                                  height: "16px",
                                  width: "1rem",
                                  alignSelf: "normal",
                                  fill: "rgb(157, 160, 165)",
                                  flexShrink: 0,
                                  marginLeft: "6px",
                                }}
                              >
                                <path
                                  d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                                  style={{ boxSizing: "border-box" }}
                                ></path>
                              </svg>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <hr
                      aria-hidden="true"
                      style={{
                        boxSizing: "content-box",
                        height: "2px",
                        overflow: "visible",
                        margin: "0px",
                        flexShrink: 0,
                        borderWidth: "0px",
                        borderColor: "rgb(173, 255, 47)",
                        backgroundColor: "rgb(36, 43, 53)",
                        borderStyle: "none",
                      }}
                    />
                    <div
                      style={{ boxSizing: "border-box", margin: "0px -16px" }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          borderTopLeftRadius: "14px",
                          borderTopRightRadius: "14px",
                          color: "rgb(243, 243, 244)",
                          boxShadow: "none",
                          backgroundImage:
                            "linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0))",
                          position: "relative",
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                          overflowAnchor: "none",
                          borderRadius: "14px 14px 0px 0px",
                          backgroundColor: "rgba(0, 0, 0, 0)",
                        }}
                      >
                        <div
                          role="button"
                          aria-expanded="false"
                          aria-controls="expansion-carriers-content"
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            position: "relative",
                            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            outline: "rgb(243, 243, 244) none 0px",
                            border: "0px none rgb(243, 243, 244)",
                            margin: "0px",
                            borderRadius: "0px",
                            cursor: "pointer",
                            userSelect: "none",
                            verticalAlign: "middle",
                            appearance: "none",
                            textDecoration: "none solid rgb(243, 243, 244)",
                            color: "rgb(243, 243, 244)",
                            display: "flex",
                            transition:
                              "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                            padding: "16px",
                            minHeight: "56px",
                          }}
                        >
                          <div
                            style={{
                              boxSizing: "border-box",
                              display: "flex",
                              WebkitBoxFlex: 1,
                              flexGrow: 1,
                              transition:
                                "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                              margin: "0px",
                            }}
                          >
                            <p
                              style={{
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "16px",
                                lineHeight: "22px",
                                fontWeight: 500,
                              }}
                            >
                              Transporteurs
                            </p>
                          </div>
                          <div
                            style={{
                              boxSizing: "border-box",
                              display: "flex",
                              color: "rgb(243, 243, 244)",
                              transform: "matrix(1, 0, 0, 1, 0, 0)",
                              transition:
                                "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                              marginRight: "-16px",
                              padding: "0px 16px",
                            }}
                          >
                            <svg
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                boxSizing: "border-box",
                                fill: "rgb(141, 232, 254)",
                                height: "24px",
                                width: "1.5rem",
                              }}
                            >
                              <path
                                d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                            </svg>
                          </div>
                        </div>
                        <div
                          style={{
                            minHeight: "0pxbox-sizing:border-box",
                            boxSizing: "border-box",
                            height: "0px",
                            overflow: "hidden",
                            transition:
                              "height 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            visibility: "hidden",
                          }}
                        >
                          <div
                            style={{
                              boxSizing: "border-box",
                              display: "flex",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{ boxSizing: "border-box", width: "100%" }}
                            >
                              <div
                                aria-labelledby="expansion-carriers-summary"
                                role="region"
                                style={{ boxSizing: "border-box" }}
                              >
                                <div
                                  style={{
                                    boxSizing: "border-box",
                                    marginBottom: "16px",
                                    padding: "0px 16px",
                                  }}
                                >
                                  <ul
                                    style={{
                                      boxSizing: "border-box",
                                      listStyle: "outside none none",
                                      margin: "0px",
                                      padding: "0px",
                                    }}
                                  >
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/tgv-inoui"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        TGV INOUI
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/ouigo"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        OUIGO
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/ter"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        TER
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/blablacar-bus"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        BlaBlaCar Bus
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/flixbus"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        FlixBus
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/blablacar"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        BlaBlaCar
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/intercites"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        INTERCITÉS
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/tgv-lyria"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        TGV Lyria
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/eurostar"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Eurostar
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/tgv-inoui-bruxelles"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        TGV INOUI vers Bruxelles
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/db-sncf-cooperation"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        DB SNCF Voyageurs en coopération
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/tgv-inoui-espagne"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        TGV INOUI vers l'Espagne
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/tgv-inoui-italie"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        TGV INOUI vers l'Italie
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/tgv-inoui-luxembourg"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        TGV INOUI vers le Luxembourg
                                      </a>
                                    </li>
                                    <li style={{ boxSizing: "border-box" }}>
                                      <a
                                        href="/obb-nightjet"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        OBB Nightjet
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr
                        aria-hidden="true"
                        style={{
                          boxSizing: "content-box",
                          height: "2px",
                          overflow: "visible",
                          flexShrink: 0,
                          borderWidth: "0px",
                          borderColor: "rgb(173, 255, 47)",
                          backgroundColor: "rgb(36, 43, 53)",
                          borderStyle: "none",
                          margin: "0px 16px",
                        }}
                      />
                      <div
                        style={{
                          boxSizing: "border-box",
                          color: "rgb(243, 243, 244)",
                          boxShadow: "none",
                          backgroundImage:
                            "linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0))",
                          position: "relative",
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                          overflowAnchor: "none",
                          borderRadius: "0px",
                          backgroundColor: "rgba(0, 0, 0, 0)",
                        }}
                      >
                        <div
                          role="button"
                          aria-expanded="false"
                          aria-controls="expansion-topDestination-content"
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            position: "relative",
                            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            outline: "rgb(243, 243, 244) none 0px",
                            border: "0px none rgb(243, 243, 244)",
                            margin: "0px",
                            borderRadius: "0px",
                            cursor: "pointer",
                            userSelect: "none",
                            verticalAlign: "middle",
                            appearance: "none",
                            textDecoration: "none solid rgb(243, 243, 244)",
                            color: "rgb(243, 243, 244)",
                            display: "flex",
                            transition:
                              "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                            padding: "16px",
                            minHeight: "56px",
                          }}
                        >
                          <div
                            style={{
                              boxSizing: "border-box",
                              display: "flex",
                              WebkitBoxFlex: 1,
                              flexGrow: 1,
                              transition:
                                "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                              margin: "0px",
                            }}
                          >
                            <p
                              style={{
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "16px",
                                lineHeight: "22px",
                                fontWeight: 500,
                              }}
                            >
                              Itinéraires populaires
                            </p>
                          </div>
                          <div
                            style={{
                              boxSizing: "border-box",
                              display: "flex",
                              color: "rgb(243, 243, 244)",
                              transform: "matrix(1, 0, 0, 1, 0, 0)",
                              transition:
                                "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                              marginRight: "-16px",
                              padding: "0px 16px",
                            }}
                          >
                            <svg
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                boxSizing: "border-box",
                                fill: "rgb(141, 232, 254)",
                                height: "24px",
                                width: "1.5rem",
                              }}
                            >
                              <path
                                d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                            </svg>
                          </div>
                        </div>
                        <div
                          style={{
                            minHeight: "0pxbox-sizing:border-box",
                            boxSizing: "border-box",
                            height: "0px",
                            overflow: "hidden",
                            transition:
                              "height 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            visibility: "hidden",
                          }}
                        >
                          <div
                            style={{
                              boxSizing: "border-box",
                              display: "flex",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{ boxSizing: "border-box", width: "100%" }}
                            >
                              <div
                                aria-labelledby="expansion-topDestination-summary"
                                role="region"
                                style={{ boxSizing: "border-box" }}
                              >
                                <div
                                  style={{
                                    boxSizing: "border-box",
                                    marginBottom: "16px",
                                    padding: "0px 16px",
                                  }}
                                >
                                  <ul
                                    style={{
                                      boxSizing: "border-box",
                                      listStyle: "outside none none",
                                      margin: "0px",
                                      padding: "0px",
                                    }}
                                  >
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/trajet/paris/bordeaux"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Paris Bordeaux
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/trajet/paris/marseille"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Paris Marseille
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/trajet/bordeaux/paris"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Bordeaux Paris
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/trajet/paris/lyon"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Paris Lyon
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/trajet/paris/bruxelles"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Paris Bruxelles
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/trajet/paris/strasbourg"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Paris Strasbourg
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/trajet/paris/toulouse"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Paris Toulouse
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/trajet/toulouse/paris"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Toulouse Paris
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/trajet/lyon/paris"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Lyon Paris
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/trajet/paris/amsterdam"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Paris Amsterdam
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/trajet/paris/lille"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Paris Lille
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/trajet/nantes/paris"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Nantes Paris
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/trajet/paris/geneve"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Paris Genève
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/trajet/paris/barcelone"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Paris Barcelone
                                      </a>
                                    </li>
                                    <li style={{ boxSizing: "border-box" }}>
                                      <a
                                        href="/train/trajet/paris/nantes"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Paris Nantes
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr
                        aria-hidden="true"
                        style={{
                          boxSizing: "content-box",
                          height: "2px",
                          overflow: "visible",
                          flexShrink: 0,
                          borderWidth: "0px",
                          borderColor: "rgb(173, 255, 47)",
                          backgroundColor: "rgb(36, 43, 53)",
                          borderStyle: "none",
                          margin: "0px 16px",
                        }}
                      />
                      <div
                        style={{
                          boxSizing: "border-box",
                          color: "rgb(243, 243, 244)",
                          boxShadow: "none",
                          backgroundImage:
                            "linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0))",
                          position: "relative",
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                          overflowAnchor: "none",
                          borderRadius: "0px",
                          backgroundColor: "rgba(0, 0, 0, 0)",
                        }}
                      >
                        <div
                          role="button"
                          aria-expanded="false"
                          aria-controls="expansion-topWeekEndDestination-content"
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            position: "relative",
                            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            outline: "rgb(243, 243, 244) none 0px",
                            border: "0px none rgb(243, 243, 244)",
                            margin: "0px",
                            borderRadius: "0px",
                            cursor: "pointer",
                            userSelect: "none",
                            verticalAlign: "middle",
                            appearance: "none",
                            textDecoration: "none solid rgb(243, 243, 244)",
                            color: "rgb(243, 243, 244)",
                            display: "flex",
                            transition:
                              "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                            padding: "16px",
                            minHeight: "56px",
                          }}
                        >
                          <div
                            style={{
                              boxSizing: "border-box",
                              display: "flex",
                              WebkitBoxFlex: 1,
                              flexGrow: 1,
                              transition:
                                "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                              margin: "0px",
                            }}
                          >
                            <p
                              style={{
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "16px",
                                lineHeight: "22px",
                                fontWeight: 500,
                              }}
                            >
                              Trajets Transporteurs
                            </p>
                          </div>
                          <div
                            style={{
                              boxSizing: "border-box",
                              display: "flex",
                              color: "rgb(243, 243, 244)",
                              transform: "matrix(1, 0, 0, 1, 0, 0)",
                              transition:
                                "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                              marginRight: "-16px",
                              padding: "0px 16px",
                            }}
                          >
                            <svg
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                boxSizing: "border-box",
                                fill: "rgb(141, 232, 254)",
                                height: "24px",
                                width: "1.5rem",
                              }}
                            >
                              <path
                                d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                            </svg>
                          </div>
                        </div>
                        <div
                          style={{
                            minHeight: "0pxbox-sizing:border-box",
                            boxSizing: "border-box",
                            height: "0px",
                            overflow: "hidden",
                            transition:
                              "height 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            visibility: "hidden",
                          }}
                        >
                          <div
                            style={{
                              boxSizing: "border-box",
                              display: "flex",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{ boxSizing: "border-box", width: "100%" }}
                            >
                              <div
                                aria-labelledby="expansion-topWeekEndDestination-summary"
                                role="region"
                                style={{ boxSizing: "border-box" }}
                              >
                                <div
                                  style={{
                                    boxSizing: "border-box",
                                    marginBottom: "16px",
                                    padding: "0px 16px",
                                  }}
                                >
                                  <ul
                                    style={{
                                      boxSizing: "border-box",
                                      listStyle: "outside none none",
                                      margin: "0px",
                                      padding: "0px",
                                    }}
                                  >
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/tgv-inoui/trajet/lille/paris"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        TGV INOUI Lille-Paris
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/tgv-inoui/trajet/lyon/paris"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        TGV INOUI Lyon-Paris
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/tgv-inoui/trajet/paris/nice"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        TGV INOUI Paris-Nice
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/tgv-inoui/trajet/marseille/paris"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        TGV INOUI Marseille-Paris
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/tgv-inoui/trajet/paris/nantes"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        TGV INOUI Paris-Nantes
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/ouigo/trajet/fleury-les-aubrais/paris"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        OUIGO Fleury-les-Aubrais-Paris
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/ouigo/trajet/paris/fleury-les-aubrais"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        OUIGO Paris-Fleury-les-Aubrais
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/ouigo/trajet/rennes/paris"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        OUIGO Rennes-Paris
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/ouigo/trajet/marseille/lyon"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        OUIGO Marseille-Lyon
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/ouigo/trajet/nantes/paris"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        OUIGO Nantes-Paris
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/ter/trajet/paris/trouville-deauville"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        TER Paris-Trouville Deauville
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/ter/trajet/trouville-deauville/paris"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        TER Trouville Deauville-Paris
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/ter/trajet/paris/le-mans"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        TER Paris-Le Mans
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/ter/trajet/le-mans/paris"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        TER Le Mans-Paris
                                      </a>
                                    </li>
                                    <li style={{ boxSizing: "border-box" }}>
                                      <a
                                        href="/ter/trajet/nice/cannes"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        TER Nice-Cannes
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr
                        aria-hidden="true"
                        style={{
                          boxSizing: "content-box",
                          height: "2px",
                          overflow: "visible",
                          flexShrink: 0,
                          borderWidth: "0px",
                          borderColor: "rgb(173, 255, 47)",
                          backgroundColor: "rgb(36, 43, 53)",
                          borderStyle: "none",
                          margin: "0px 16px",
                        }}
                      />
                      <div
                        style={{
                          boxSizing: "border-box",
                          borderBottomLeftRadius: "14px",
                          borderBottomRightRadius: "14px",
                          color: "rgb(243, 243, 244)",
                          boxShadow: "none",
                          backgroundImage:
                            "linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0))",
                          position: "relative",
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                          overflowAnchor: "none",
                          borderRadius: "0px 0px 14px 14px",
                          backgroundColor: "rgba(0, 0, 0, 0)",
                        }}
                      >
                        <div
                          role="button"
                          aria-expanded="false"
                          aria-controls="expansion-topGenericDestination-content"
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            position: "relative",
                            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            outline: "rgb(243, 243, 244) none 0px",
                            border: "0px none rgb(243, 243, 244)",
                            margin: "0px",
                            borderRadius: "0px",
                            cursor: "pointer",
                            userSelect: "none",
                            verticalAlign: "middle",
                            appearance: "none",
                            textDecoration: "none solid rgb(243, 243, 244)",
                            color: "rgb(243, 243, 244)",
                            display: "flex",
                            transition:
                              "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                            padding: "16px",
                            minHeight: "56px",
                          }}
                        >
                          <div
                            style={{
                              boxSizing: "border-box",
                              display: "flex",
                              WebkitBoxFlex: 1,
                              flexGrow: 1,
                              transition:
                                "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                              margin: "0px",
                            }}
                          >
                            <p
                              style={{
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "16px",
                                lineHeight: "22px",
                                fontWeight: 500,
                              }}
                            >
                              Top destinations
                            </p>
                          </div>
                          <div
                            style={{
                              boxSizing: "border-box",
                              display: "flex",
                              color: "rgb(243, 243, 244)",
                              transform: "matrix(1, 0, 0, 1, 0, 0)",
                              transition:
                                "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                              marginRight: "-16px",
                              padding: "0px 16px",
                            }}
                          >
                            <svg
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                boxSizing: "border-box",
                                fill: "rgb(141, 232, 254)",
                                height: "24px",
                                width: "1.5rem",
                              }}
                            >
                              <path
                                d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                            </svg>
                          </div>
                        </div>
                        <div
                          style={{
                            minHeight: "0pxbox-sizing:border-box",
                            boxSizing: "border-box",
                            height: "0px",
                            overflow: "hidden",
                            transition:
                              "height 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            visibility: "hidden",
                          }}
                        >
                          <div
                            style={{
                              boxSizing: "border-box",
                              display: "flex",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{ boxSizing: "border-box", width: "100%" }}
                            >
                              <div
                                aria-labelledby="expansion-topGenericDestination-summary"
                                role="region"
                                style={{ boxSizing: "border-box" }}
                              >
                                <div
                                  style={{
                                    boxSizing: "border-box",
                                    marginBottom: "16px",
                                    padding: "0px 16px",
                                  }}
                                >
                                  <ul
                                    style={{
                                      boxSizing: "border-box",
                                      listStyle: "outside none none",
                                      margin: "0px",
                                      padding: "0px",
                                    }}
                                  >
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/france"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train France
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/france/ile-de-france/paris"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Paris
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/france/auvergne-rhone-alpes/lyon"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Lyon
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/france/nouvelle-aquitaine/bordeaux"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Bordeaux
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/france/grand-est/strasbourg"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Strasbourg
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/france/pays-de-la-loire/nantes"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Nantes
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/france/provence-alpes-cote-d-azur/marseille"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Marseille
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/france/hauts-de-france/lille"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Lille
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/france/ile-de-france/chessy/marne-la-vallee-chessy"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Marne-la-Vallée Chessy
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/pays-bas/amsterdam"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Amsterdam
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/royaume-uni/angleterre/londres"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Londres
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/espagne/catalogne/barcelone"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Barcelone
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/france/bretagne/rennes"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Rennes
                                      </a>
                                    </li>
                                    <li
                                      style={{
                                        boxSizing: "border-box",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <a
                                        href="/train/italie"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Italie
                                      </a>
                                    </li>
                                    <li style={{ boxSizing: "border-box" }}>
                                      <a
                                        href="/train/suisse"
                                        style={{
                                          boxSizing: "border-box",
                                          backgroundColor: "rgba(0, 0, 0, 0)",
                                          margin: "0px",
                                          fontFamily:
                                            "Avenir",
                                          fontSize: "13px",
                                          lineHeight: "18px",
                                          fontWeight: 500,
                                          textDecoration:
                                            "none solid rgb(157, 160, 165)",
                                          cursor: "pointer",
                                          position: "relative",
                                          WebkitBoxAlign: "center",
                                          alignItems: "center",
                                          display: "inline-flex",
                                          color: "rgb(157, 160, 165)",
                                          textAlign: "left",
                                          padding: "8px 0px",
                                          width: "fit-content",
                                        }}
                                      >
                                        Train Suisse
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr
                        aria-hidden="true"
                        style={{
                          boxSizing: "content-box",
                          height: "2px",
                          overflow: "visible",
                          flexShrink: 0,
                          borderWidth: "0px",
                          borderColor: "rgb(173, 255, 47)",
                          backgroundColor: "rgb(36, 43, 53)",
                          borderStyle: "none",
                          margin: "0px 16px",
                        }}
                      />
                    </div>
                    <ul
                      style={{
                        marginLeft: "auto",
                        marginRight: "auto",
                        boxSizing: "border-box",
                        display: "grid",
                        gap: "8px",
                        gridTemplateColumns:
                          "repeat(auto-fit, minmax(7.75rem, 1fr))",
                        maxWidth: "320px",
                        width: "100%",
                        listStyle: "outside none none",
                        padding: "0px",
                      }}
                    >
                      <li
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          WebkitBoxPack: "center",
                          justifyContent: "center",
                        }}
                      >
                        <a
                          href="https://apps.apple.com/fr/app/id343889987"
                          target="_blank"
                          title="Télécharger dans l'app store - Nouvel Onglet"
                          rel="noopener noreferrer"
                          style={{
                            boxSizing: "border-box",
                            backgroundColor: "rgb(36, 43, 53)",
                            margin: "0px",
                            fontFamily:
                              "Avenir",
                            fontSize: "13px",
                            lineHeight: "18px",
                            fontWeight: 500,
                            textDecoration: "none solid rgb(255, 255, 255)",
                            cursor: "pointer",
                            position: "relative",
                            display: "flex",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            borderColor: "rgb(36, 43, 53)",
                            borderRadius: "24px",
                            color: "rgb(255, 255, 255)",
                            padding: "0px",
                            width: "100%",
                            maxWidth: "156px",
                            minHeight: "48px",
                            minWidth: "124px",
                          }}
                        >
                          <img
                            src="/assets/media/pushstore/fr/store-apple.svg"
                            alt="Télécharger dans l'app store"
                            style={{
                              boxSizing: "border-box",
                              borderStyle: "none",
                              height: "48px",
                            }}
                          />
                        </a>
                      </li>
                      <li
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          WebkitBoxPack: "center",
                          justifyContent: "center",
                        }}
                      >
                        <a
                          href="https://play.google.com/store/apps/details?id=com.vsct.vsc.mobile.horaireetresa.android&amp;hl=fr"
                          target="_blank"
                          title="Disponible sur google play - Nouvel Onglet"
                          rel="noopener noreferrer"
                          style={{
                            boxSizing: "border-box",
                            backgroundColor: "rgb(36, 43, 53)",
                            margin: "0px",
                            fontFamily:
                              "Avenir",
                            fontSize: "13px",
                            lineHeight: "18px",
                            fontWeight: 500,
                            textDecoration: "none solid rgb(255, 255, 255)",
                            cursor: "pointer",
                            position: "relative",
                            display: "flex",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            borderColor: "rgb(36, 43, 53)",
                            borderRadius: "24px",
                            color: "rgb(255, 255, 255)",
                            padding: "0px",
                            width: "100%",
                            maxWidth: "156px",
                            minHeight: "48px",
                            minWidth: "124px",
                          }}
                        >
                          <img
                            src="/assets/media/pushstore/fr/store-google.svg"
                            alt="Disponible sur google play"
                            style={{
                              boxSizing: "border-box",
                              borderStyle: "none",
                              height: "48px",
                            }}
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};
